import { useEffect, useMemo, useRef, useState } from 'react';
import './DashboardPage.scss';
// import logoImg from '../../assets/images/logo.png';
import logoImg from '../../assets/svg/logo.svg';
import dillLogoWithText from '../../assets/svg/dill_logo_with_text.svg';
import coinsLightImg from '../../assets/svg/coins_light.svg';
import coinsImg from '../../assets/svg/coins.svg';
import { Link, Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import {
  logoutUser,
  getUserDetails,
  getRutterPublicKey,
  processRutterPublicToken,
  getCurrentSupplier,
} from '../../redux/services/authService';
import { useRutterLink } from 'react-rutter-link';
import { getQuickBooksAuthUri, disconnectQuickbooks } from '../../redux/services/invoicesService';
import { AppButton } from '../../components/general/AppButton/AppButton';
import {
  HelpCircle,
  ChevronLeft,
  ChevronDown,
  AlertTriangle,
  AlertCircle,
  RefreshCcw,
  Menu,
  X,
  Settings,
} from 'react-feather';
import { COLORS } from '../../utils/colors';
import {
  ClipboardText,
  Plugs,
  UserCircle,
  CaretUp,
  CaretDown,
  Checks,
  FileText,
  CreditCard,
  FileX,
  Database,
  UserSquare,
  Briefcase,
  Lock,
  MegaphoneSimple,
  PlusCircle,
  FilePlus,
  Files,
  Calculator,
  Coins,
  ChartBar,
  Monitor,
  Money,
  Gear,
  ClockCounterClockwise,
  HandFist,
  Handshake,
  BellSimple,
  Books,
  TreeStructure,
  Graph,
  ShieldCheck,
  ListChecks,
  MagnifyingGlass,
  Lightning,
  Repeat,
} from 'phosphor-react';
import { ConnectQuickBooksModal } from '../../components/modules/invoices/ConnectQuickBooksModal/ConnectQuickBooksModal';
import { clearQuickBooksAuthUri } from '../../redux/globalSlices/invoiceSlice';
import quickBooksConnectSuccessIcon from '../../assets/svg/quickbooks_connect_success.svg';
import quickBooksConnectFailedIcon from '../../assets/svg/quickbooks_connect_failed.svg';
import quickBooksConnectWarnIcon from '../../assets/svg/quickbooks_connect_warn.svg';
import d1Logo from '../../assets/images/d1-logo.png';
import netsuiteLogo from '../../assets/images/netsuite-logo.png';
import sageLogo from '../../assets/images/sage-logo.png';
import p21Logo from '../../assets/images/p21-logo.png';
import eclipseApiLogo from '../../assets/images/eclipse-api.png';
import agilityLogo from '../../assets/svg/agility-logo.svg';
import { AuthorizeQuickbooksConnect } from '../../components/modules/invoices/AuthorizeQuickbooksConnect/AuthorizeQuickbooksConnect';
import { useComponentVisible } from '../../utils/hooks/useComponentVisible';
import { useWindowActualHeight, useWindowActualWidth } from '../../utils/domTools';
import {
  MainBuyer,
  capitalizeWordsInSentence,
  isUserSupplierAdmin,
  isSupplierAdminUser,
} from '@dill/dill-shared';
import { AppVerifyBusinessModal } from '../../components/general/AppVerifyBusinesModal/AppVerifyBusinessModal';
import {
  getDwollaCustomer,
  getSupplierRegistrationStatus,
} from '../../redux/services/paymentsService';
import { refreshAccounting } from '../../redux/services/quickBooksService';
import { twMerge } from 'tailwind-merge';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { toast } from 'react-toastify';

import {
  buildSupplierPath,
  canBuyerPaySupplier,
  downloadFile,
  getLoginSupplierId,
  isCreditAppRestricted,
  isNavItemDisabled,
  openDillToast,
  sortMainBuyersByLoginSupplier,
  stripSupplierPrefix,
} from '../../utils/helpers';
import { REACT_APP_RUTTER_PUBLIC_KEY } from '../../utils/constants';

import { updateSelectedMainBuyer } from '../../redux/globalSlices/buyersSlice';
import { useParamMainBuyerId } from '../../utils/hooks/useParamMainBuyerId';
import { useParamSupplierId } from '../../utils/hooks/useParamSupplierId';
import { AppCustomerSettingsModal } from '../../components/general/AppCustomerSettingsModal/AppCustomerSettingsModal';
import { PreviewModeBanner } from '../../components/general/PreviewModeBanner/PreviewModeBanner';

import {
  updateSupplierQueueJobsRunning,
  updateSupplierManualUploadProgress,
} from '../../redux/globalSlices/genericSlice';
import { AppManualImportCSVModal } from '../../components/general/AppManualImportCSVModal/AppManualImportCSVModal';
import { onValue, ref as realTimeDBRef } from 'firebase/database';
import type { Unsubscribe } from 'firebase/database';
import { myRealtimeDB } from '../../firebase/config';
import AppManualImportProgressModal from '../../components/general/AppManualImportProgressModal/AppManualImportProgressModal';
import AppAuthorizeInforDistSXModal from '../../components/general/AppAuthorizeInforDistSXModal';
import AppP21ManualUploadSettingsModal from '../../components/general/AppP21ManualUploadSettingsModal';
import AppDistributionOneConnectionModal from '../../components/general/AppDistributionOneConnectionModal/AppDistributionOneConnectionModal';
import { AppInputField } from '../../components/general/AppInputField/AppInputField';
import AppSage100ConnectionModal from '../../components/general/AppSage100ConnectionModal/AppSage100ConnectionModal';
import AppP21ConnectionModal from '../../components/general/AppP21ConnectionModal/AppP21ConnectionModal';
import AppEclipseConnectionModal from '../../components/general/AppEclipseConnectionModal/AppEclipseConnectionModal';
import AppDmsiConnectionModal from '../../components/general/AppDmsiConnectionModal/AppDmsiConnectionModal';
import { resetSupplierJobs } from '../../redux/globalSlices/supplierJobsSlice';
import { resetSuppliersRootState } from '../../redux/globalSlices/suppliersSlice';
import { AddFixedAmountPaymentsModal } from '../../components/modules/fixedAmountPayments/AddFixedAmountPaymentsModal';
import { getSupplierOpenDisputesCount } from '../../redux/services/disputesService';
import { DillButton } from '../../components/general/Dill';
import { useBuyerUserPermissions } from '../../utils/hooks/useBuyerUserPermissions';

interface RouteDetails {
  id: string;
  parentId: string;
  name: string;
  path: string;
  isNested: boolean;
  isDisabled: boolean;
  type: string;
  section?: string;
  notification?: { data: string };
  icon?: {
    inActive: any;
    active: any;
  };
  subRoutes?: RouteDetails[];
}

const masonWestSupplierId = 'uy0jvcnqZaghfC3wgqUB';

export const AppProfileView = ({
  onMenuClick,
  modeType,
  platformName,
}: {
  onMenuClick: (item: any) => void;
  modeType: string;
  platformName: string;
}) => {
  const navigate = useNavigate();
  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);
  const { supplierRegistrationStatus, loadingList: paymentLoadingList } = useAppSelector(
    (state) => state.payments
  );
  const { selectedMainBuyer } = useAppSelector((state) => state.buyers);
  const { integrationDetails } = useAppSelector((state) => state.supplierIntegrationDetails);
  const { user, currentSupplier, isCurrentSupplierIntegrated } = useAppSelector(
    (state) => state.auth
  );
  const isVerified = useMemo(() => {
    return supplierRegistrationStatus?.isFullyRegistered;
  }, [user, supplierRegistrationStatus?.isFullyRegistered]);

  return (
    <div className=" flex items-center relative">
      <div
        className="flex items-center border border-gray-200 rounded-lg px-2 py-1.5 cursor-pointer hover:border-blue-300 hover:bg-blue-50/40 transition-all duration-150 gap-1"
        onClick={() => {
          setIsComponentVisible(!isComponentVisible);
        }}>
        <div className="w-7 h-7 sm:w-8 sm:h-8 bg-gradient-to-br from-[#3762FB] to-[#5b7dff] mr-1 sm:mr-2 flex items-center justify-center rounded-full shadow-sm ring-2 ring-blue-100">
          {user && (
            <p className="text-white text-xs font-semibold">{`${
              user.firstName ? user.firstName?.toLocaleUpperCase().slice(0, 1) : ''
            }${user.lastName ? user.lastName?.toLocaleUpperCase().slice(0, 1) : ''}`}</p>
          )}
        </div>
        {user && (
          <p className="font-semibold mr-1 hidden md:block text-sm text-gray-700">
            {`${user.firstName || ''} ${user.lastName || ''}`}{' '}
          </p>
        )}
        <ChevronDown size={16} className="text-gray-500" />
      </div>
      {isComponentVisible && (
        <div
          ref={ref}
          className="bg-white right-0 absolute w-fit top-12 shadow-xl border border-gray-100 rounded-xl min-h-fit py-3 px-3 flex flex-col z-50 min-w-[210px]">
          <div
            className="flex cursor-pointer hover:bg-slate-50 rounded-lg p-1.5 transition-colors duration-150"
            onClick={() => {
              if (selectedMainBuyer && modeType === 'Buyer') {
                navigate(`/companies/${selectedMainBuyer.id}/profile`);
              } else if (modeType === 'Supplier') {
                navigate(buildSupplierPath(currentSupplier?.id, '/profile'));
              }
            }}>
            <div className="flex w-9 h-9 bg-gradient-to-br from-[#3762FB] to-[#5b7dff] rounded-full items-center justify-center shadow-sm ring-2 ring-blue-100 flex-shrink-0">
              {user && (
                <p className="text-white p-0 whitespace-nowrap text-sm font-semibold">{`${
                  user.firstName ? user.firstName?.toLocaleUpperCase().slice(0, 1) : ''
                }${user.lastName ? user.lastName?.toLocaleUpperCase().slice(0, 1) : ''}`}</p>
              )}
            </div>

            <div className="flex flex-col ml-2 min-w-0">
              {user && (
                <p className="text-sm font-semibold text-gray-800 truncate">{`${
                  user.firstName || ''
                } ${user.lastName || ''}`}</p>
              )}
              <p className="text-xs text-gray-500 truncate">{user?.email}</p>
              <div className="text-xs py-0.5 px-2 text-[#3762FB] rounded-md bg-blue-50 w-fit mt-0.5 font-medium">
                View Profile
              </div>
            </div>
          </div>
          {user?.roles.includes('SUPPLIER') && modeType === 'Supplier' && (
            <div className="h-0.5 GREY_100-BG w-full mt-3"></div>
          )}
          <div className="w-full">
            {user?.roles.includes('SUPPLIER') &&
              !isCurrentSupplierIntegrated &&
              modeType === 'Supplier' &&
              currentSupplier &&
              currentSupplier?.integrationType != 'INFOR_DIST_SX' &&
              currentSupplier?.integrationType != 'LIEN_ONLY_UPLOAD' && (
                <AppButton
                  text={
                    currentSupplier &&
                    ((currentSupplier?.integrationType?.startsWith('CODAT_') &&
                      integrationDetails?.codat?.companyId &&
                      integrationDetails?.codat?.connectorId) ||
                      (currentSupplier.integrationType?.startsWith('RUTTER_') &&
                        integrationDetails?.rutter?.connectionId))
                      ? integrationDetails?.codat &&
                        integrationDetails?.codat.currency &&
                        integrationDetails?.codat.currency !== 'USD'
                        ? `'${integrationDetails?.codat.currency}' currency not supported `
                        : `Finalizing  ${platformName} Connection`
                      : `Connect ${platformName}`
                  }
                  type={
                    currentSupplier &&
                    currentSupplier.integrationType?.startsWith('CODAT_') &&
                    integrationDetails?.codat?.companyId &&
                    integrationDetails?.codat?.connectorId &&
                    integrationDetails?.codat.currency &&
                    integrationDetails?.codat.currency !== 'USD'
                      ? 'ERROR'
                      : 'PRIMARY'
                  }
                  buttonStyles={{ marginTop: '10px', width: '100%' }}
                  icon={<Plugs color={COLORS.WHITE} />}
                  onClick={() => {
                    if (!isCurrentSupplierIntegrated) {
                      onMenuClick('quickBooks');
                    }
                  }}
                />
              )}
            {user?.roles.includes('SUPPLIER') &&
              currentSupplier &&
              isCurrentSupplierIntegrated &&
              (currentSupplier.integrationType?.startsWith('RUTTER_') ||
                currentSupplier.integrationType?.startsWith('CODAT_') ||
                currentSupplier.integrationType?.startsWith('QBO') ||
                currentSupplier.integrationType === 'DISTRIBUTION_ONE' ||
                currentSupplier.integrationType === 'P21' ||
                currentSupplier.integrationType === 'SAGE_100' ||
                currentSupplier.integrationType === 'ECLIPSE' ||
                currentSupplier.integrationType === 'AGILITY_DMSI') &&
              modeType === 'Supplier' &&
              currentSupplier.integrationType !== 'MANUAL_UPLOAD' &&
              currentSupplier.integrationType !== 'ABLE_MANUAL_UPLOAD' &&
              currentSupplier.integrationType !== 'P21_MANUAL_UPLOAD' &&
              currentSupplier.integrationType !== 'DDI_MANUAL_UPLOAD' &&
              currentSupplier.integrationType !== 'ECLIPSE_MANUAL_UPLOAD' && (
                <AppButton
                  text={`${platformName} Connected`}
                  type="SECONDARY"
                  onClick={() => {
                    if (!isCurrentSupplierIntegrated) {
                      onMenuClick('quickBooks');
                    } else {
                      onMenuClick('disconnect');
                    }
                  }}
                  buttonStyles={{ marginTop: '10px', width: '100%' }}
                />
              )}
            {user?.roles.includes('SUPPLIER') &&
              modeType === 'Supplier' &&
              currentSupplier &&
              currentSupplier.integrationType == 'INFOR_DIST_SX' && (
                <AppButton
                  text={
                    currentSupplier &&
                    currentSupplier?.integrationType == 'INFOR_DIST_SX' &&
                    !integrationDetails?.inforDistSX?.isSetupDone
                      ? 'Connect to InforDistSX'
                      : 'Connected to InforDistSX'
                  }
                  type={
                    currentSupplier &&
                    currentSupplier?.integrationType == 'INFOR_DIST_SX' &&
                    !integrationDetails?.inforDistSX?.isSetupDone
                      ? 'PRIMARY'
                      : 'SECONDARY'
                  }
                  buttonStyles={{ marginTop: '10px', width: '100%' }}
                  icon={
                    currentSupplier &&
                    currentSupplier?.integrationType == 'INFOR_DIST_SX' &&
                    !integrationDetails?.inforDistSX?.isSetupDone ? (
                      <Plugs color={COLORS.WHITE} />
                    ) : (
                      <></>
                    )
                  }
                  onClick={() => onMenuClick('inforDistSX')}
                />
              )}
            {user?.roles.includes('SUPPLIER') &&
              isSupplierAdminUser({ user, supplier: currentSupplier }) &&
              modeType === 'Supplier' &&
              currentSupplier?.integrationType === 'P21_MANUAL_UPLOAD' && (
                <AppButton
                  text={
                    integrationDetails?.p21ManualUpload?.isAutomatedUploadEnabled
                      ? 'P21 Automated Upload On'
                      : 'Set Up P21 Automated Upload'
                  }
                  type={
                    integrationDetails?.p21ManualUpload?.isAutomatedUploadEnabled
                      ? 'SECONDARY'
                      : 'PRIMARY'
                  }
                  buttonStyles={{ marginTop: '10px', width: '100%' }}
                  icon={
                    integrationDetails?.p21ManualUpload?.isAutomatedUploadEnabled ? (
                      <></>
                    ) : (
                      <Plugs color={COLORS.WHITE} />
                    )
                  }
                  onClick={() => onMenuClick('p21ManualUpload')}
                />
              )}
            {user?.roles.includes('SUPPLIER') &&
              isUserSupplierAdmin({ user, supplier: currentSupplier }) &&
              modeType === 'Supplier' &&
              currentSupplier?.integrationType != 'LIEN_ONLY_UPLOAD' &&
              !currentSupplier?.onlyCreditAppIntegration && (
                <AppButton
                  text={
                    paymentLoadingList.includes('getSupplierRegistrationStatus')
                      ? 'Checking Status'
                      : currentSupplier?.dwollaCustomerStatus === undefined ||
                        currentSupplier?.dwollaCustomerStatus === 'create'
                      ? 'Verify Your Business'
                      : isVerified
                      ? 'Business Verified'
                      : 'Finish Verification'
                  }
                  type="TERTIARY"
                  buttonStyles={{
                    marginTop: '10px',
                    width: '100%',
                    alignSelf: 'center',
                  }}
                  icon={
                    isVerified ? (
                      <Checks color={COLORS.SUCCESS_600} />
                    ) : (
                      <AlertCircle color={COLORS.ERROR_600} size={18} />
                    )
                  }
                  onClick={() => {
                    // if (currentSupplier?.dwollaCustomerStatus !== 'verified') {
                    onMenuClick('connectDwolla');
                    // }
                  }}
                />
              )}
          </div>
          {user?.roles.includes('MAIN_BUYER') &&
            modeType === 'Buyer' &&
            selectedMainBuyer &&
            selectedMainBuyer?.isPaid && (
              <AppButton
                text={'Lien Waiver Settings'}
                type="TERTIARY"
                buttonStyles={{
                  marginTop: '10px',
                  width: '100%',
                  alignSelf: 'center',
                }}
                onClick={() => {
                  onMenuClick('lienWaiverSettings');
                }}
              />
            )}
          <div className="h-0.5 GREY_100-BG w-full mt-3"></div>
          <div
            className="my-2 cursor-pointer"
            onClick={() => {
              onMenuClick('logout');
            }}>
            <p className="GREY_700-CLR text-sm">Logout</p>
          </div>
        </div>
      )}
    </div>
  );
};
// interface RouteType {
//   id: string;
//   name: string;
//   path: string;
//   icon: any;
// }

const Dropdown = ({
  subRoutes,
  pathSplit,
  onOpenDropdown,
  closeSideNav,
}: {
  subRoutes: RouteDetails[];
  pathSplit: any;
  onOpenDropdown: (value: boolean) => void;
  closeSideNav: () => void;
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const { user } = useAppSelector((state) => state.auth);
  const { selectedMainBuyer, basicSupplier } = useAppSelector((state) => state.buyers);
  const { isPreviewMode, previewMainBuyer, previewSupplierDomainId } = useAppSelector(
    (state) => state.preview
  );
  const [isOpen, setIsOpen] = useState(false);
  const [filteredMainBuyers, setFilteredMainBuyers] = useState<MainBuyer[]>([]);
  const [searchText, setSearchText] = useState('');
  const [selectedMainBuyerId] = useParamMainBuyerId();

  const handleSelectItem = (mainBuyer: MainBuyer) => {
    if (mainBuyer.id) {
      dispatch(updateSelectedMainBuyer(mainBuyer));
      setSearchText('');

      let newLocation = '';
      if (
        (location.pathname.split('/').length == 5 &&
          location.pathname.includes('/companies') &&
          location.pathname.includes('/invoices')) ||
        location.pathname.includes('/help')
      ) {
        newLocation = `/companies/${mainBuyer.id}/invoices`;
      } else if (
        (location.pathname.split('/').length >= 5 &&
          location.pathname.includes('/buyerLienReleases')) ||
        location.pathname.includes('/help')
      ) {
        const locationArray = location.pathname.split('/');
        const splitLocationPath = locationArray.slice(0, 4);
        newLocation = splitLocationPath
          .map((item, i) => {
            if (i === 2) {
              return mainBuyer.id;
            }
            return item;
          })
          .join('/');
      } else {
        newLocation = location.pathname
          .split('/')
          .map((item, i) => {
            if (i === 2) {
              return mainBuyer.id;
            }
            return item;
          })
          .join('/');
      }
      navigate(newLocation);
      setIsOpen(!isOpen);
      onOpenDropdown(!isOpen);
    }
  };

  useEffect(() => {
    // `filteredMainBuyers` is ordered with the login supplier's main buyers first, so the head
    // of the list is the company the user most likely logged in for.
    const defaultMainBuyer = filteredMainBuyers[0];
    if (
      !params?.mainBuyerId &&
      user?.userMainBuyers &&
      user?.userMainBuyers.length > 0 &&
      defaultMainBuyer
    ) {
      dispatch(updateSelectedMainBuyer(defaultMainBuyer));
      if (location.pathname.startsWith('/adminTemplates')) {
        return;
      } else if (location.pathname.startsWith('/help')) {
        return;
      } else if (location.pathname.startsWith('/companies')) {
        navigate(`/companies/${defaultMainBuyer.id}/mainBuyerDashboard`);
      } else if (location.pathname.startsWith('/buyerLienReleases')) {
        navigate(`/buyerLienReleases/${defaultMainBuyer.id}/overview`);
      } else {
        navigate(`/companies/${defaultMainBuyer.id}/invoices`);
      }
    }
    if (params && params.mainBuyerId && user?.userMainBuyers && defaultMainBuyer) {
      const mainBuyer = filteredMainBuyers.find((mb) => mb.id === selectedMainBuyerId);
      if (mainBuyer) {
        dispatch(updateSelectedMainBuyer(mainBuyer));
      } else {
        dispatch(updateSelectedMainBuyer(defaultMainBuyer));
      }
    }
    if (previewMainBuyer) {
      dispatch(updateSelectedMainBuyer(previewMainBuyer));
    }
  }, [location.pathname, selectedMainBuyerId, filteredMainBuyers, isPreviewMode, previewMainBuyer]);

  useEffect(() => {
    if (isPreviewMode && previewMainBuyer && previewSupplierDomainId) {
      navigate(`/companies/${previewMainBuyer.id}/invoices/${previewSupplierDomainId}`);
    }
    return () => {
      return;
    };
  }, [isPreviewMode, previewMainBuyer]);

  const toggleDropdown = () => {
    // Disable dropdown toggle when in preview mode
    if (isPreviewMode) {
      return;
    }
    if (user?.userMainBuyers && user?.userMainBuyers.length > 0) {
      setIsOpen(!isOpen);
      onOpenDropdown(!isOpen);
    } else {
      setIsOpen(false);
      onOpenDropdown(false);
    }
  };
  const handleSelectRoute = (id: string) => {
    const defaultMainBuyer = filteredMainBuyers[0];
    if (
      user?.userMainBuyers &&
      user?.userMainBuyers.length > 0 &&
      location.pathname.startsWith('/help') &&
      defaultMainBuyer
    ) {
      navigate(`/companies/${defaultMainBuyer.id}`);
    } else if (selectedMainBuyerId) {
      navigate(`/companies/${selectedMainBuyerId}/${id}`);
      setIsOpen(false);
      onOpenDropdown(false);
      closeSideNav();
    } else if (previewMainBuyer) {
      navigate(`/companies/${previewMainBuyer.id}`);
    }
  };
  useEffect(() => {
    if (user?.userMainBuyers) {
      let mainBuyersList = user?.userMainBuyers;
      if (searchText) {
        const filtMB = user?.userMainBuyers.filter((mainBuyer) =>
          mainBuyer.name.toLowerCase().includes(searchText.trim().toLowerCase())
        );
        console.log({ filtMB, searchText });
        mainBuyersList = filtMB;
      }
      mainBuyersList = mainBuyersList
        .filter((mb) => !mb?.isDeactivated && !mb?.isCODCustomer)
        .filter((mb) => mb?.syncSupplierId !== masonWestSupplierId);
      // Main buyers of the supplier the user logged in through come first, so the list opens on
      // the companies they're here for and `[0]` is a sensible default.
      setFilteredMainBuyers(
        sortMainBuyersByLoginSupplier(mainBuyersList, basicSupplier?.id || getLoginSupplierId())
      );
    }
    if (isPreviewMode && previewMainBuyer) {
      setFilteredMainBuyers([previewMainBuyer]);
    }

    return () => {};
  }, [searchText, user?.userMainBuyers, isPreviewMode, previewMainBuyer, basicSupplier?.id]);

  return (
    <div className="relative ">
      {isOpen && (
        <div className="bg-slate-50 my-1 sticky top-0 ">
          <AppInputField
            value={searchText}
            placeholder="Search"
            onTextChange={(val) => {
              setSearchText(val);
            }}
          />
        </div>
      )}

      {!isOpen && (isPreviewMode || (user?.userMainBuyers && user?.userMainBuyers.length > 0)) && (
        <button
          className="sticky flex w-full justify-between flex-row items-center px-3 py-2 bg-white border-[1.5px] border-[#e4eaf1] rounded-[10px] transition-[border-color,box-shadow] duration-150 hover:border-[#a5b4fc] hover:shadow-[0_0_0_3px_rgba(55,98,251,0.08)] mb-1"
          onClick={toggleDropdown}>
          {isPreviewMode && previewMainBuyer ? (
            <p className="text-left text-sm font-medium text-[#64748b] capitalize tracking-[-0.02em]">
              {previewMainBuyer.name.toLocaleLowerCase()}
              <span className="ml-2 text-xs text-blue-500">(Preview)</span>
            </p>
          ) : selectedMainBuyer ? (
            <p className="text-left text-sm font-medium text-[#64748b] capitalize tracking-[-0.02em]">
              {selectedMainBuyer.name.toLocaleLowerCase()}
            </p>
          ) : null}

          {!isPreviewMode && (isOpen ? <CaretUp size={16} /> : <CaretDown size={16} />)}
          {!selectedMainBuyer && !isPreviewMode && (
            <div className="text-sm text-slate-400">Select company</div>
          )}
        </button>
      )}
      {isOpen && selectedMainBuyer && (
        <div>
          {filteredMainBuyers &&
            filteredMainBuyers.map((mainBuyer) => (
              <button
                className={twMerge(
                  'flex px-3 py-2 rounded-lg w-full mt-1.5 text-left transition-colors duration-100',
                  selectedMainBuyerId === mainBuyer.id
                    ? 'bg-gradient-to-br from-[#3762fb] to-[#5b7dff] shadow-[0_2px_8px_rgba(55,98,251,0.25)]'
                    : 'bg-[#f8fafc] hover:bg-[#eff1fe]'
                )}
                key={`buyer_route_${mainBuyer.id}`}
                onClick={() => handleSelectItem(mainBuyer)}>
                <p
                  className={twMerge(
                    'text-left font-semibold text-sm capitalize',
                    selectedMainBuyerId === mainBuyer.id ? 'text-white' : 'text-[#121a2d]'
                  )}>
                  {mainBuyer.name.toLocaleLowerCase()}
                </p>
              </button>
            ))}
        </div>
      )}
      {!isOpen && (
        <div>
          {subRoutes.map((subRoute) => {
            return (
              <div
                onClick={() => {
                  if (!subRoute.isDisabled) {
                    handleSelectRoute(subRoute.id);
                  }
                }}
                key={subRoute.id}
                className={twMerge(
                  'flex h-9 items-center px-2 w-full rounded-lg rounded-lg transition-all duration-150 group',
                  subRoute.isDisabled ? 'cursor-not-allowed' : 'cursor-pointer',
                  `${pathSplit[3]}` === subRoute.id && !subRoute.isDisabled
                    ? 'bg-blue-100/70 border-[#3762FB] shadow-sm'
                    : 'hover:bg-blue-50 border-transparent',
                  subRoute.isDisabled ? 'bg-slate-400' : ''
                )}>
                {`${pathSplit[3]}` === subRoute.id && subRoute?.icon && subRoute?.icon.active}
                {`${pathSplit[3]}` !== subRoute.id && subRoute?.icon && subRoute?.icon.inActive}
                <p
                  className={
                    'text-sm ml-3.5 ' +
                    (`${pathSplit[3]}` === subRoute.id
                      ? 'PRIMARY_500-CLR'
                      : 'GREY_500-CLR font-medium group-hover:text-gray-900')
                  }>
                  {subRoute.name.substring(0, 17)}
                  {subRoute.name.length > 17 && '...'}
                </p>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export const DashboardPage = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const width = useWindowActualWidth();
  const height = useWindowActualHeight();
  const {
    user,
    currentSupplier,
    userSuppliers,
    firebaseUserId,
    rutterPublicKey,
    isCurrentSupplierIntegrated,
  } = useAppSelector((state) => state.auth);
  const { selectedMainBuyer, selectedBuyerSuppliers } = useAppSelector((state) => state.buyers);
  const { integrationDetails } = useAppSelector((state) => state.supplierIntegrationDetails);
  const { isPreviewMode, previewMainBuyer } = useAppSelector((state) => state.preview);
  const { supplierQueueJobsRunning } = useAppSelector((state) => state.generic);
  const { quickBooksAuthUri, isGetQuickBooksAuthUrlFailed, selectedSupplierForBuyer } =
    useAppSelector((state) => state.invoice);
  const { selectedLiensRelease } = useAppSelector((state) => state.liens);
  const { selectedJob } = useAppSelector((state) => state.jobs);
  const [selectedMainBuyerId] = useParamMainBuyerId();
  const [routeSupplierId] = useParamSupplierId();
  const params = useParams();
  const { supplierManualUploadProgress } = useAppSelector((state) => state.generic);
  const { supplierOpenDisputesCount } = useAppSelector((state) => state.disputes);
  const { buyerUserCanPay } = useBuyerUserPermissions();

  const [openConnectQuickBooksModal, setOpenConnectQuickBooksModal] = useState(false);
  const [isAppDistributionOneConnectionModalOpen, setIsAppDistributionOneConnectionModalOpen] =
    useState(false);
  const [isAppSage100ConnectionModalOpen, setIsAppSage100ConnectionModalOpen] = useState(false);
  const [isAppP21ConnectionModalOpen, setIsAppP21ConnectionModalOpen] = useState(false);
  const [isAppEclipseConnectionModalOpen, setIsAppEclipseConnectionModalOpen] = useState(false);
  const [isAppDmsiConnectionModalOpen, setIsAppDmsiConnectionModalOpen] = useState(false);
  const [openConnectSuccessQuickBooksModal, setOpenConnectSuccessQuickBooksModal] = useState(false);
  const [openConnectFailedQuickBooksModal, setOpenConnectFailedQuickBooksModal] = useState(false);
  const [openDisconnectQuickBooksModal, setOpenDisconnectQuickBooksModal] = useState(false);
  const [openDisconnectSuccessModal, setOpenDisconnectSuccessModal] = useState(false);
  const [openDisconnectFailedModal, setOpenDisconnectFailedModal] = useState(false);
  const [openConfirmDisconnectQuickBooksModal, setOpenConfirmDisconnectQuickBooksModal] =
    useState(false);
  const [selectAccountTypeDropdown, setSelectAccountTypeDropdown] = useState(false);
  const accountTypeDropdownRef = useRef<HTMLDivElement>(null);
  const [supplierSelectorDropdown, setSupplierSelectorDropdown] = useState(false);
  const [supplierSearchQuery, setSupplierSearchQuery] = useState('');
  const supplierSelectorDropdownRef = useRef<HTMLDivElement>(null);
  const [selectAccountType, setSelectAccountType] = useState('');
  const [businessVerifyCustomerModal, setBusinessVerifyCustomerModal] = useState(false);
  const [lienWaiverSettingsModal, setLienWaiverSettingsModal] = useState(false);
  const [inforDistSXModal, setInforDistSXModal] = useState(false);
  const [p21ManualUploadSettingsModal, setP21ManualUploadSettingsModal] = useState(false);
  const [hideTabWhenDropDownOpen, setHideTabWhenDropDownOpen] = useState(false);
  const [openImportCSVModal, setOpenImportCSVModal] = useState(false);
  const [isAppManualImportProgressModalOpen, setIsAppManualImportProgressModalOpen] =
    useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isFixedAmountPaymentsModalOpen, setIsFixedAmountPaymentsModalOpen] = useState(false);

  const [platformName, setPlatformName] = useState('');
  const [platformLogo, setPlatformLogo] = useState<any>(null);
  useEffect(() => {
    if (currentSupplier?.integrationType === 'INFOR_DIST_SX') {
      setPlatformName('InforDistSX');
    }
    if (
      currentSupplier?.integrationType === 'RUTTER_QBD' ||
      currentSupplier?.integrationType === 'RUTTER_QBO' ||
      currentSupplier?.integrationType === 'QBO'
    ) {
      setPlatformName('Quickbooks');
    }

    if (currentSupplier?.integrationType === 'RUTTER_NETSUITE') {
      setPlatformName('Netsuite');
      setPlatformLogo(netsuiteLogo);
    }

    if (currentSupplier?.integrationType === 'DISTRIBUTION_ONE') {
      setPlatformName('Distribution one');
      setPlatformLogo(d1Logo);
    }
    if (currentSupplier?.integrationType === 'SAGE_100') {
      setPlatformName('Sage 100');
      setPlatformLogo(sageLogo);
    }
    if (currentSupplier?.integrationType === 'P21') {
      setPlatformName('Prophet 21');
      setPlatformLogo(p21Logo);
    }
    if (currentSupplier?.integrationType === 'ECLIPSE') {
      setPlatformLogo(eclipseApiLogo);
      setPlatformName('Eclipse');
    }
    if (currentSupplier?.integrationType === 'AGILITY_DMSI') {
      setPlatformName('Agility DMSi');
      setPlatformLogo(agilityLogo);
    }

    return () => {};
  }, [currentSupplier?.integrationType]);
  useEffect(() => {
    if (isCurrentSupplierIntegrated) {
      setOpenConnectQuickBooksModal(false);
    }
    return () => {};
  }, [isCurrentSupplierIntegrated]);
  useEffect(() => {
    if (supplierManualUploadProgress) {
      setIsAppManualImportProgressModalOpen(true);
    }

    return () => {};
  }, [supplierManualUploadProgress]);
  const getSupplierManualUploadStatus = (supplierId: string) => {
    const suppliersManualUploadProgressRef = realTimeDBRef(
      myRealtimeDB,
      `suppliersManualUploadProgress/${supplierId}`
    );
    const subScription = onValue(suppliersManualUploadProgressRef, (snapshot) => {
      const data = snapshot.val();
      if (data?.status) {
        dispatch(
          updateSupplierManualUploadProgress({
            status: data?.status,
            message: data?.message,
            jobs: data?.jobs ?? null,
          })
        );
      } else {
        dispatch(updateSupplierManualUploadProgress(null));
      }
    });
    return subScription;
  };

  useEffect(() => {
    let supplierManualUploadStatusUnSubscribe: Unsubscribe | null = null;
    if (currentSupplier?.id) {
      supplierManualUploadStatusUnSubscribe = getSupplierManualUploadStatus(currentSupplier?.id);
      dispatch(getSupplierOpenDisputesCount({ supplierId: currentSupplier?.id }));
    }
    return () => {
      if (supplierManualUploadStatusUnSubscribe) {
        supplierManualUploadStatusUnSubscribe();
      }
    };
  }, [currentSupplier?.id]);

  const getSupplierQueueJobsRunning = (jobSupplierId: string) => {
    const lastSyncTimeRef = realTimeDBRef(myRealtimeDB, `suppliersRunningJobs/${jobSupplierId}`);
    const subScription = onValue(lastSyncTimeRef, (snapshot) => {
      const data = snapshot.val();
      if (data && Object.keys(data).length > 0) {
        dispatch(updateSupplierQueueJobsRunning(Object.keys(data)));
      } else {
        dispatch(updateSupplierQueueJobsRunning([]));
      }
    });
    return subScription;
  };
  useEffect(() => {
    if (selectedMainBuyer) {
      let getSupplierQueueJobsRunningUnSubscribe: Unsubscribe | null = null;
      if (selectedMainBuyer.syncSupplierId) {
        getSupplierQueueJobsRunningUnSubscribe = getSupplierQueueJobsRunning(
          selectedMainBuyer.syncSupplierId
        );
      }
      return () => {
        if (getSupplierQueueJobsRunningUnSubscribe) {
          getSupplierQueueJobsRunningUnSubscribe();
        }
      };
    }

    return () => {};
  }, [selectedMainBuyer]);

  useEffect(() => {
    if (isPreviewMode) {
      setSelectAccountType('Buyer');
    } else if (user?.roles) {
      const savedSelectAccountType = localStorage.getItem('selectAccountType');
      const searchParams = new URLSearchParams(location.search);
      const emailFromLink = searchParams.get('email');

      if (
        user?.roles.includes('SUPPLIER') ||
        user?.roles.includes('SUB_SUPPLIER') ||
        user?.roles.includes('CREDIT_APP_SALES')
      ) {
        if (
          savedSelectAccountType === 'Buyer' &&
          (user?.roles.includes('BUYER') || user?.roles.includes('MAIN_BUYER'))
        ) {
          setSelectAccountType(savedSelectAccountType);
        } else {
          setSelectAccountType('Supplier');
        }
      } else if (user?.roles.includes('BUYER') || user?.roles.includes('MAIN_BUYER')) {
        if (
          savedSelectAccountType === 'Supplier' &&
          (user?.roles.includes('SUPPLIER') ||
            user?.roles.includes('SUB_SUPPLIER') ||
            user?.roles.includes('CREDIT_APP_SALES'))
        ) {
          setSelectAccountType(savedSelectAccountType);
        } else {
          setSelectAccountType('Buyer');
        }
      }
    }
  }, [user?.roles]);

  useEffect(() => {
    if (
      isUserSupplierAdmin({ user, supplier: currentSupplier }) &&
      selectAccountType === 'Supplier' &&
      currentSupplier
    ) {
      dispatch(getSupplierRegistrationStatus({ supplierId: currentSupplier?.id || '' }));
      dispatch(getDwollaCustomer({ email: currentSupplier?.email }));
      if (currentSupplier?.integrationType?.startsWith('RUTTER_')) {
        dispatch(getRutterPublicKey({ supplierId: currentSupplier?.id || '' }));
      }
    }
    return () => {};
  }, []);
  useEffect(() => {
    if (
      isUserSupplierAdmin({ user, supplier: currentSupplier }) &&
      selectAccountType === 'Supplier' &&
      currentSupplier
    ) {
      dispatch(getSupplierRegistrationStatus({ supplierId: currentSupplier?.id || '' }));
      dispatch(getDwollaCustomer({ email: currentSupplier?.email }));
    }
    return () => {};
  }, [user, selectAccountType, currentSupplier]);

  useEffect(() => {
    if (selectAccountType && !isPreviewMode) {
      const mainRoles = !user ? [] : user?.roles.filter((role) => role !== 'DILL_ADMIN');
      const buyerExcludedPaths = ['/buyerLienReleases', '/help'];
      if (selectedMainBuyerId) {
        buyerExcludedPaths.push(`/companies/${selectedMainBuyerId}`);
      } else {
        buyerExcludedPaths.push('/companies');
      }
      if (
        selectAccountType === 'Buyer' &&
        buyerExcludedPaths.every((path) => !location.pathname.startsWith(path))
      ) {
        if (mainRoles.includes('BUYER') && selectedMainBuyerId) {
          navigate(`/companies/${selectedMainBuyerId}/mainBuyerDashboard`);
        } else if (mainRoles.includes('BUYER')) {
          navigate('/companies');
        } else if (mainRoles.includes('MAIN_BUYER') && selectedMainBuyerId) {
          navigate(`/buyerLienReleases/${selectedMainBuyerId}/overview`);
        }
      }
      if (
        selectAccountType === 'Supplier' &&
        !location.pathname.startsWith('/supplier/') &&
        ['/customers'].includes(stripSupplierPrefix(location.pathname))
      ) {
        if (isCreditAppRestricted(user?.roles)) {
          navigate(
            buildSupplierPath(routeSupplierId || currentSupplier?.id, '/creditApplications')
          );
        } else if (mainRoles.includes('AR_SALES') && !mainRoles.includes('AR_ALL')) {
          navigate(buildSupplierPath(routeSupplierId || currentSupplier?.id, '/paymentRequests'));
        } else if (mainRoles.includes('SUPPLIER')) {
          navigate(buildSupplierPath(routeSupplierId || currentSupplier?.id, '/dashboardPayments'));
        } else if (mainRoles.includes('SUB_SUPPLIER')) {
          navigate('/lienReleases');
        }
      }
    }
  }, [selectAccountType, selectedMainBuyerId, user?.roles]);

  useEffect(() => {
    if (
      selectedMainBuyerId &&
      user?.userMainBuyers &&
      !isPreviewMode &&
      selectAccountType === 'Buyer'
    ) {
      const mainBuyer = user?.userMainBuyers
        .filter((mb) => !mb?.isDeactivated && !mb?.isCODCustomer)
        .find((mb) => mb.id === selectedMainBuyerId);
      if (!mainBuyer) {
        navigate('/companies');
      }
    }
  }, [user?.userMainBuyers, isPreviewMode, selectedMainBuyerId]);

  const routePaths = useMemo(
    () => [{ name: 'Invoices', path: '/invoices', image: coinsLightImg, imageActive: coinsImg }],
    []
  );

  const nestedRoutePaths = useMemo(() => {
    const allRoutes: RouteDetails[] = [];

    const isNavDisabled = ({ section, id }: { section: string; id: string }): boolean =>
      isNavItemDisabled({ section, id, roles: user?.roles });

    if (
      user &&
      (user.roles.includes('CREDIT_APP_SALES') ||
        user.roles.includes('SUB_SUPPLIER') ||
        user.roles.includes('SUPPLIER')) &&
      selectAccountType === 'Supplier'
    ) {
      const creditAppPaths: RouteDetails[] = [
        {
          id: 'dashboardCreditApplications',
          parentId: 'supplierPaths',
          name: 'Dashboard',
          path: `/dashboardCreditApplications`,
          isNested: false,
          isDisabled: isNavDisabled({ section: 'CREDIT', id: 'dashboardCreditApplications' }),
          type: '',
          section: 'CREDIT',
          icon: {
            inActive: <Graph color={COLORS.GREY_400} size={20} />,
            active: <Graph color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        },
        {
          id: 'creditApplications',
          parentId: 'supplierPaths',
          name: 'Credit Applications',
          path: `/creditApplications`,
          isNested: false,
          isDisabled: isNavDisabled({ section: 'CREDIT', id: 'creditApplications' }),
          type: '',
          section: 'CREDIT',
          icon: {
            inActive: <Coins color={COLORS.GREY_400} size={20} />,
            active: <Coins color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        },
        {
          id: 'approvalWorkflows',
          parentId: 'supplierPaths',
          name: 'Approval Workflows',
          path: `/approvalWorkflows`,
          isNested: false,
          isDisabled: isNavDisabled({ section: 'CREDIT', id: 'approvalWorkflows' }),
          type: '',
          section: 'CREDIT',
          icon: {
            inActive: <TreeStructure color={COLORS.GREY_400} size={20} />,
            active: <TreeStructure color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        },
        {
          id: 'tradeReferencesPool',
          parentId: 'supplierPaths',
          name: 'Trade Reference Pool',
          path: `/tradeReferencesPool`,
          isNested: false,
          isDisabled: isNavDisabled({ section: 'CREDIT', id: 'tradeReferencesPool' }),
          type: '',
          section: 'CREDIT',
          icon: {
            inActive: <Books color={COLORS.GREY_400} size={20} />,
            active: <Books color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        },
      ];
      allRoutes.push({
        id: 'creditAppPaths',
        parentId: '',
        name: '',
        path: ``,
        isNested: false,
        isDisabled: false,
        type: 'GROUPED_UNNESTED',
        subRoutes: creditAppPaths,
      });
    }
    if (
      user &&
      (user.roles.includes('SUPPLIER') ||
        user.roles.includes('SUB_SUPPLIER') ||
        user.roles.includes('CREDIT_APP_SALES') ||
        user.roles.includes('AR_ALL') ||
        user.roles.includes('AR_SALES')) &&
      selectAccountType === 'Supplier'
    ) {
      const supplierPaths: RouteDetails[] = [
        {
          id: `dashboardPayments`,
          parentId: 'supplierPaths',
          name: 'Dashboard',
          path: `/dashboardPayments`,
          isNested: false,
          isDisabled: isNavDisabled({ section: 'AR + ONLINE PAYMENTS', id: 'dashboardPayments' }),
          type: '',
          section: 'AR + ONLINE PAYMENTS',
          icon: {
            inActive: <Graph color={COLORS.GREY_400} size={20} />,
            active: <Graph color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        },
        {
          id: 'customers',
          parentId: 'supplierPaths',
          name: 'Customers',
          path: `/customers`,
          isNested: false,
          isDisabled: isNavDisabled({ section: 'AR + ONLINE PAYMENTS', id: 'customers' }),
          type: '',
          section: 'AR + ONLINE PAYMENTS',
          icon: {
            inActive: <UserCircle color={COLORS.GREY_400} size={20} />,
            active: <UserCircle color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        },
        // These tabs are no longer being used
        // {
        //   id: 'invoices',
        //   parentId: 'supplierPaths',
        //   name: 'Invoices',
        //   path: `/invoices`,
        //   isNested: false,
        //   isDisabled: false,
        //   type: '',
        //   icon: {
        //     inActive: <ClipboardText color={COLORS.GREY_400} size={20} />,
        //     active: <ClipboardText color={COLORS.PRIMARY_500} size={20} weight="fill" />,
        //   },
        // },
        // {
        //   id: 'salesReceipts',
        //   parentId: 'supplierPaths',
        //   name: 'Sales Receipts',
        //   path: `/salesReceipts`,
        //   isNested: false,
        //   isDisabled: false,
        //   type: '',
        //   icon: {
        //     inActive: <FileText color={COLORS.GREY_400} size={20} weight="light" />,
        //     active: <FileText color={COLORS.PRIMARY_500} size={20} weight="fill" />,
        //   },
        // },
        {
          id: `payments`,
          parentId: 'supplierPaths',
          name: 'Payments',
          path: `/payments`,
          isNested: false,
          isDisabled: isNavDisabled({ section: 'AR + ONLINE PAYMENTS', id: 'payments' }),
          type: '',
          section: 'AR + ONLINE PAYMENTS',
          icon: {
            inActive: <CreditCard color={COLORS.GREY_400} size={20} />,
            active: <CreditCard color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        },
        {
          id: `virtualPOS`,
          parentId: 'supplierPaths',
          name: 'Virtual POS',
          path: `/virtualPOS`,
          isNested: false,
          isDisabled: isNavDisabled({ section: 'AR + ONLINE PAYMENTS', id: 'virtualPOS' }),
          type: '',
          section: 'AR + ONLINE PAYMENTS',
          icon: {
            inActive: <Calculator color={COLORS.GREY_400} size={20} />,
            active: <Calculator color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        },
        {
          id: `paymentRequests`,
          parentId: 'supplierPaths',
          name: 'Payment Requests',
          path: `/paymentRequests`,
          isNested: false,
          isDisabled: isNavDisabled({ section: 'AR + ONLINE PAYMENTS', id: 'paymentRequests' }),
          type: '',
          section: 'AR + ONLINE PAYMENTS',
          icon: {
            inActive: <CreditCard color={COLORS.GREY_400} size={20} />,
            active: <CreditCard color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        },
        {
          id: `disputes`,
          parentId: 'supplierPaths',
          name: 'Disputes',
          path: `/disputes`,
          isNested: false,
          isDisabled: isNavDisabled({ section: 'AR + ONLINE PAYMENTS', id: 'disputes' }),
          type: '',
          section: 'AR + ONLINE PAYMENTS',
          icon: {
            inActive: <HandFist color={COLORS.GREY_400} size={20} />,
            active: <HandFist color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
          notification: { data: supplierOpenDisputesCount ? `${supplierOpenDisputesCount}` : '' },
        },
        {
          id: `collectionTasks`,
          parentId: 'supplierPaths',
          name: 'Collection Tasks',
          path: `/collectionTasks`,
          isNested: false,
          isDisabled: isNavDisabled({ section: 'AR + ONLINE PAYMENTS', id: 'collectionTasks' }),
          type: '',
          section: 'AR + ONLINE PAYMENTS',
          icon: {
            inActive: <ListChecks color={COLORS.GREY_400} size={20} />,
            active: <ListChecks color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        },
        {
          id: `promiseToPays`,
          parentId: 'supplierPaths',
          name: 'Promise to Pay',
          path: `/promiseToPays`,
          isNested: false,
          isDisabled: isNavDisabled({ section: 'AR + ONLINE PAYMENTS', id: 'promiseToPays' }),
          type: '',
          section: 'AR + ONLINE PAYMENTS',
          icon: {
            inActive: <Handshake color={COLORS.GREY_400} size={20} />,
            active: <Handshake color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        },
        {
          id: `collectionSequencesAndTriggers`,
          parentId: 'supplierPaths',
          name: 'Collection Workflows',
          path: `/collectionSequencesAndTriggers`,
          isNested: false,
          isDisabled: isNavDisabled({
            section: 'AR + ONLINE PAYMENTS',
            id: 'collectionSequencesAndTriggers',
          }),
          type: '',
          section: 'AR + ONLINE PAYMENTS',
          icon: {
            inActive: <Lightning color={COLORS.GREY_400} size={20} />,
            active: <Lightning color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        },
        ...(currentSupplier?.invoicingSettings?.dillDoesInvoicing
          ? [
              {
                id: `invoiceDelivery`,
                parentId: 'supplierPaths',
                name: 'Invoice Delivery',
                path: `/invoiceDelivery`,
                isNested: false,
                isDisabled: isNavDisabled({
                  section: 'AR + ONLINE PAYMENTS',
                  id: 'invoiceDelivery',
                }),
                type: '',
                section: 'AR + ONLINE PAYMENTS',
                icon: {
                  inActive: <BellSimple color={COLORS.GREY_400} size={20} />,
                  active: <BellSimple color={COLORS.PRIMARY_500} size={20} weight="fill" />,
                },
              },
            ]
          : []),

        {
          id: `cashApplication`,
          parentId: 'supplierPaths',
          name: 'Review Queue',
          path: `/cashApplication`,
          isNested: true,
          isDisabled: isNavDisabled({ section: 'AI CASH APPLICATION', id: 'cashApplication' }),
          type: '',
          section: 'AI CASH APPLICATION',
          icon: {
            inActive: <ClipboardText color={COLORS.GREY_400} size={20} />,
            active: <ClipboardText color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        },
        {
          id: `/cashApplication/postHistory`,
          parentId: 'supplierPaths',
          name: 'Post History',
          path: `/cashApplication/postHistory`,
          isNested: true,
          isDisabled: isNavDisabled({
            section: 'AI CASH APPLICATION',
            id: '/cashApplication/postHistory',
          }),
          type: '',
          section: 'AI CASH APPLICATION',
          icon: {
            inActive: <ClockCounterClockwise color={COLORS.GREY_400} size={20} />,
            active: <ClockCounterClockwise color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        },
        {
          id: `/cashApplication/dataIntegrations`,
          parentId: 'supplierPaths',
          name: 'Data Integrations',
          path: `/cashApplication/dataIntegrations`,
          isNested: true,
          isDisabled: isNavDisabled({
            section: 'AI CASH APPLICATION',
            id: '/cashApplication/dataIntegrations',
          }),
          type: '',
          section: 'AI CASH APPLICATION',
          icon: {
            inActive: <Plugs color={COLORS.GREY_400} size={20} />,
            active: <Plugs color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        },
        {
          id: `/cashApplication/settings`,
          parentId: 'supplierPaths',
          name: 'Settings',
          path: `/cashApplication/settings`,
          isNested: true,
          isDisabled: isNavDisabled({
            section: 'AI CASH APPLICATION',
            id: '/cashApplication/settings',
          }),
          type: '',
          section: 'AI CASH APPLICATION',
          icon: {
            inActive: <Gear color={COLORS.GREY_400} size={20} />,
            active: <Gear color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        },
        {
          id: `supplierJobs`,
          parentId: 'supplierPaths',
          name: 'Jobs',
          path: `/supplierJobs`,
          isNested: false,
          isDisabled: isNavDisabled({ section: 'LIENS', id: 'supplierJobs' }),
          type: '',
          section: 'LIENS',
          icon: {
            inActive: <Briefcase color={COLORS.GREY_400} size={20} />,
            active: <Briefcase color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        },
        {
          id: `preliminaryNotices`,
          parentId: 'preliminaryNoticesPaths',
          name: 'Preliminary Notices',
          path: `/preliminaryNotices/overview`,
          isNested: false,
          isDisabled: isNavDisabled({ section: 'LIENS', id: 'preliminaryNotices' }),
          type: '',
          section: 'LIENS',
          icon: {
            inActive: <MegaphoneSimple color={COLORS.GREY_400} size={20} />,
            active: <MegaphoneSimple color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        },
        {
          id: `liens`,
          parentId: 'liensPaths',
          name: 'Liens',
          path: `/liens/overview`,
          isNested: false,
          isDisabled: isNavDisabled({ section: 'LIENS', id: 'liens' }),
          type: '',
          section: 'LIENS',
          icon: {
            inActive: <Files color={COLORS.GREY_400} size={20} />,
            active: <Files color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        },
      ];
      allRoutes.push({
        id: 'supplierPaths',
        parentId: '',
        name: '',
        path: ``,
        isNested: false,
        isDisabled: selectAccountType === 'Supplier' && !user?.roles.includes('SUPPLIER'),
        type: 'GROUPED_UNNESTED',
        subRoutes: supplierPaths,
      });
      // allRoutes.push(...supplierPath);
      // allRoutes = [...allRoutes, ...supplierPath];
    }
    // if (
    //   user &&
    //   (user.roles.includes('SUPPLIER') || user.roles.includes('SUB_SUPPLIER')) &&
    //   currentSupplier &&
    //   currentSupplier.integrationType &&
    //   (currentSupplier.integrationType === 'ABLE_MANUAL_UPLOAD' ||
    //     currentSupplier.integrationType === 'MANUAL_UPLOAD' ||
    //     currentSupplier.integrationType === 'INFOR_DIST_SX' ||
    //     currentSupplier.integrationType === 'DISTRIBUTION_ONE' ||
    //     currentSupplier.integrationType === 'SAGE_100' ||
    //     currentSupplier.integrationType === 'P21') &&
    //   selectAccountType === 'Supplier'
    // ) {
    // const supplierPaths: RouteDetails[] = [
    //   {
    //     id: 'invoices',
    //     parentId: 'supplierPaths',
    //     name: 'Invoices',
    //     path: `/invoices`,
    //     isNested: false,
    //     isDisabled: false,
    //     type: '',
    //     icon: {
    //       inActive: <ClipboardText color={COLORS.GREY_400} size={20} />,
    //       active: <ClipboardText color={COLORS.PRIMARY_500} size={20} weight="fill" />,
    //     },
    //   },
    // ];
    // allRoutes.push({
    //   id: 'supplierPaths',
    //   parentId: '',
    //   name: '',
    //   path: ``,
    //   isNested: false,
    //   isDisabled: selectAccountType === 'Supplier' && !user?.roles.includes('SUPPLIER'),
    //   type: 'GROUPED_UNNESTED',
    //   subRoutes: supplierPaths,
    // });
    // allRoutes.push(...supplierPath);
    // allRoutes = [...allRoutes, ...supplierPath];
    // }
    if (
      user &&
      (user.roles.includes('SUB_SUPPLIER') || user.roles.includes('SUPPLIER')) &&
      selectAccountType === 'Supplier'
    ) {
      const releasesPaths: RouteDetails[] = [
        {
          id: `lienReleases`,
          parentId: 'releasesPaths',
          name: 'Lien Waivers',
          path: `/lienReleases`,
          isNested: false,
          isDisabled: isNavDisabled({ section: 'LIENS', id: 'lienReleases' }),
          type: '',
          section: 'LIENS',
          icon: {
            inActive: <FileX color={COLORS.GREY_400} size={20} />,
            active: <FileX color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        },
      ];
      allRoutes.push({
        id: 'releasesPaths',
        parentId: '',
        name: '',
        path: ``,
        isNested: false,
        isDisabled: false,
        type: 'GROUPED_UNNESTED',
        subRoutes: releasesPaths,
      });
    }

    const isExcludedFromAdminTemplateTabs =
      process.env.REACT_APP_ENVIRONMENT !== 'production' &&
      (user?.email === 'catherine@usedill.com' || user?.email === 'tim@usedill.com');

    if (
      user &&
      !isExcludedFromAdminTemplateTabs &&
      user.roles.includes('DILL_ADMIN') &&
      (user.roles.includes('SUPPLIER') || user.roles.includes('SUB_SUPPLIER')) &&
      selectAccountType === 'Supplier'
    ) {
      const noticesPaths: RouteDetails[] = [
        {
          id: `noticeTemplates`,
          parentId: 'noticesPaths',
          name: 'Notice Templates',
          path: `/noticeTemplates/templates`,
          isNested: true,
          isDisabled: isNavDisabled({ section: 'LIENS', id: 'noticeTemplates' }),
          type: '',
          section: 'LIENS',
          icon: {
            inActive: <ClipboardText color={COLORS.GREY_400} size={20} />,
            active: <ClipboardText color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        },
        {
          id: `noticeTemplateFields`,
          parentId: 'noticesPaths',
          name: 'Notice Fields Templates',
          path: `/noticeTemplateFields`,
          isNested: true,
          isDisabled: isNavDisabled({ section: 'LIENS', id: 'noticeTemplateFields' }),
          type: '',
          section: 'LIENS',
          icon: {
            inActive: <ClipboardText color={COLORS.GREY_400} size={20} />,
            active: <ClipboardText color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        },
      ];
      allRoutes.push({
        id: 'noticesPaths',
        parentId: '',
        name: '',
        path: ``,
        isNested: false,
        isDisabled: false,
        type: 'GROUPED_UNNESTED',
        subRoutes: noticesPaths,
      });
    }
    if (
      user &&
      !isExcludedFromAdminTemplateTabs &&
      user.roles.includes('DILL_ADMIN') &&
      (user.roles.includes('SUPPLIER') || user.roles.includes('SUB_SUPPLIER')) &&
      selectAccountType === 'Supplier'
    ) {
      const filedLiensPaths: RouteDetails[] = [
        {
          id: `lienTemplates`,
          parentId: 'filedLiensPaths',
          name: 'Liens Templates',
          path: `/lienTemplates/templates`,
          isNested: true,
          isDisabled: isNavDisabled({ section: 'LIENS', id: 'lienTemplates' }),
          type: '',
          section: 'LIENS',
          icon: {
            inActive: <FilePlus color={COLORS.GREY_400} size={20} />,
            active: <FilePlus color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        },
        {
          id: `lienTemplateFields`,
          parentId: 'filedLiensPaths',
          name: 'Lien Fields Templates',
          path: `/lienTemplateFields`,
          isNested: true,
          isDisabled: isNavDisabled({ section: 'LIENS', id: 'lienTemplateFields' }),
          type: '',
          section: 'LIENS',
          icon: {
            inActive: <FileText color={COLORS.GREY_400} size={20} />,
            active: <FileText color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        },
      ];
      allRoutes.push({
        id: 'filedLiensPaths',
        parentId: '',
        name: '',
        path: ``,
        isNested: false,
        isDisabled: false,
        type: 'GROUPED_UNNESTED',
        subRoutes: filedLiensPaths,
      });
    }
    if (
      user &&
      (user.roles.includes('DILL_ADMIN') ||
        user.roles.includes('CREDIT_APP_REVIEWER') ||
        user.roles.includes('CREDIT_APP_DECISION_MAKER')) &&
      (user.roles.includes('SUPPLIER') || user.roles.includes('SUB_SUPPLIER')) &&
      selectAccountType === 'Supplier'
    ) {
      const creditTemplatesPaths: RouteDetails[] = [
        ...(user.roles.includes('DILL_ADMIN')
          ? [
              {
                id: 'creditMonitoring',
                parentId: 'supplierPaths',
                name: 'Credit Monitoring',
                path: `/creditMonitoring`,
                isNested: false,
                isDisabled: isNavDisabled({ section: 'CREDIT', id: 'creditMonitoring' }),
                type: '',
                section: 'CREDIT',
                icon: {
                  inActive: <Monitor color={COLORS.GREY_400} size={20} />,
                  active: <Monitor color={COLORS.PRIMARY_500} size={20} weight="fill" />,
                },
              },
            ]
          : []),
        {
          id: `creditApplicationRequestTemplates`,
          parentId: 'creditTemplatesPaths',
          name: 'Credit Templates',
          path: `/creditApplicationRequestTemplates/overview`,
          isNested: true,
          isDisabled: isNavDisabled({ section: 'CREDIT', id: 'creditApplicationRequestTemplates' }),
          type: '',
          section: 'CREDIT',
          icon: {
            inActive: <FilePlus color={COLORS.GREY_400} size={20} />,
            active: <FilePlus color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        },
      ];
      allRoutes.push({
        id: 'creditTemplatesPaths',
        parentId: '',
        name: '',
        path: ``,
        isNested: false,
        isDisabled: false,
        type: 'GROUPED_UNNESTED',
        subRoutes: creditTemplatesPaths,
      });
    }
    if (
      user &&
      (isPreviewMode || user.roles.includes('BUYER') || user.roles.includes('MAIN_BUYER')) &&
      selectAccountType === 'Buyer'
    ) {
      let companiesSubRoutes: RouteDetails[] = [];

      companiesSubRoutes = [
        {
          id: `mainBuyerDashboard`,
          parentId: 'companies',
          name: 'Dashboard',
          path: `/companies/${selectedMainBuyerId}/dashboard`,
          isNested: true,
          isDisabled: false,
          type: '',
          icon: {
            inActive: <Graph color={COLORS.GREY_400} size={20} />,
            active: <Graph color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        },
        {
          id: `invoices`,
          parentId: 'companies',
          name: 'Invoices',
          path: `/companies/${selectedMainBuyerId}/invoices`,
          isNested: true,
          isDisabled: false,
          type: '',
          icon: {
            inActive: <ClipboardText color={COLORS.GREY_400} size={20} />,
            active: <ClipboardText color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        },
        {
          id: `statementInvoices`,
          parentId: 'companies',
          name: 'Statements',
          path: `/companies/${selectedMainBuyerId}/statementInvoices`,
          isNested: true,
          isDisabled: false,
          type: '',
          icon: {
            inActive: <ClipboardText color={COLORS.GREY_400} size={20} />,
            active: <ClipboardText color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        },
        {
          id: `payments`,
          parentId: 'companies',
          name: 'Payments',
          path: `/companies/${selectedMainBuyerId}/payments`,
          isNested: true,
          isDisabled: false,
          type: '',
          icon: {
            inActive: <CreditCard color={COLORS.GREY_400} size={20} />,
            active: <CreditCard color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        },
        {
          id: `paymentPlan`,
          parentId: 'companies',
          name: 'Payment Plans',
          path: `/companies/${selectedMainBuyerId}/paymentPlan`,
          isNested: true,
          isDisabled: false,
          type: '',
          icon: {
            inActive: <Repeat color={COLORS.GREY_400} size={20} />,
            active: <Repeat color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        },
      ];

      allRoutes.push({
        id: 'companies',
        parentId: '',
        name: '',
        path: `/companies`,
        isDisabled: false,
        isNested: true,
        type: 'DROP_DOWN_SELECT',
        subRoutes: companiesSubRoutes,
      });
    }
    if (
      user &&
      (isPreviewMode || user.roles.includes('MAIN_BUYER') || user.roles.includes('BUYER')) &&
      selectAccountType === 'Buyer' &&
      selectedMainBuyerId
    ) {
      const lienReleasesSubRoutes: RouteDetails[] = [
        {
          id: `overview`,
          parentId: 'buyerLienReleases',
          name: 'Overview',
          path: `/buyerLienReleases/${selectedMainBuyerId}/overview`,
          isNested: true,
          isDisabled: false,
          type: '',
          icon: {
            inActive: <Database color={COLORS.GREY_400} size={20} />,
            active: <Database color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        },
        {
          id: `lienReleasesSupplier`,
          parentId: 'buyerLienReleases',
          name: 'Suppliers',
          path: `/buyerLienReleases/${selectedMainBuyerId}/lienReleasesSupplier`,
          isNested: true,
          isDisabled: false,
          type: '',
          icon: {
            inActive: <UserSquare color={COLORS.GREY_400} size={20} />,
            active: <UserSquare color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        },
        {
          id: `lienReleasesJobs`,
          parentId: 'buyerLienReleases',
          name: 'Jobs',
          path: `/buyerLienReleases/${selectedMainBuyerId}/lienReleasesJobs`,
          isNested: true,
          isDisabled: false,
          type: '',
          icon: {
            inActive: <Briefcase color={COLORS.GREY_400} size={20} />,
            active: <Briefcase color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        },
        {
          id: `templates`,
          parentId: 'buyerLienReleases',
          name: 'Templates',
          path: `/buyerLienReleases/${selectedMainBuyerId}/templates`,
          isNested: true,
          isDisabled: false,
          type: '',
          icon: {
            inActive: <ClipboardText color={COLORS.GREY_400} size={20} />,
            active: <ClipboardText color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        } as RouteDetails,
      ];
      if (!isExcludedFromAdminTemplateTabs && user.roles.includes('DILL_ADMIN')) {
        lienReleasesSubRoutes.push({
          id: `templateFields`,
          parentId: 'buyerLienReleases',
          name: 'Template Fields',
          path: `/buyerLienReleases/${selectedMainBuyerId}/templateFields`,
          isNested: true,
          isDisabled: false,
          type: '',
          icon: {
            inActive: <ClipboardText color={COLORS.GREY_400} size={20} />,
            active: <ClipboardText color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        });
      }
      allRoutes.push({
        id: `buyerLienReleases`,
        name: 'Lien Waivers',
        path: `/buyerLienReleases/${selectedMainBuyerId}/overview`,
        isNested: false,
        isDisabled: false,
        parentId: '',
        type: 'EXPANDABLE',
        subRoutes: lienReleasesSubRoutes,
        // subRoutes: [],
        icon: {
          inActive: <FileX color={COLORS.GREY_400} size={20} />,
          active: <FileX color={COLORS.PRIMARY_500} size={20} weight="fill" />,
        },
      });
    }

    if (
      user &&
      (isPreviewMode || user.roles.includes('BUYER') || user.roles.includes('MAIN_BUYER')) &&
      selectAccountType === 'Buyer'
    ) {
      let companiesSubRoutes: RouteDetails[] = [];

      companiesSubRoutes = [
        {
          id: `reporting`,
          parentId: 'companies',
          name: 'Reporting',
          path: `/companies/${selectedMainBuyerId}/reporting`,
          isNested: true,
          isDisabled: false,
          type: '',
          icon: {
            inActive: <ChartBar color={COLORS.GREY_400} size={20} />,
            active: <ChartBar color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        },
        {
          id: `profile`,
          parentId: 'companies',
          name: 'Settings',
          path: `/companies/${selectedMainBuyerId}/profile`,
          isNested: true,
          isDisabled: false,
          type: '',
          icon: {
            inActive: <Gear color={COLORS.GREY_400} size={20} />,
            active: <Gear color={COLORS.PRIMARY_500} size={20} weight="fill" />,
          },
        },
      ];

      allRoutes.push({
        id: 'companies',
        parentId: '',
        name: '',
        path: ``,
        isDisabled: false,
        isNested: false,
        type: 'STANDALONE',
        subRoutes: companiesSubRoutes,
      });
    }

    if (user && user.roles.includes('SUPPLIER') && selectAccountType === 'Supplier') {
      const supplierPaths: RouteDetails[] = [];
      supplierPaths.push({
        id: 'reports',
        parentId: 'supplierPaths',
        name: 'Reporting',
        path: `/reports`,
        isNested: false,
        isDisabled: isNavDisabled({ section: 'REPORT', id: 'reports' }),
        type: '',
        section: 'REPORT',
        icon: {
          inActive: <ChartBar color={COLORS.GREY_400} size={20} />,
          active: <ChartBar color={COLORS.PRIMARY_500} size={20} weight="fill" />,
        },
      });

      allRoutes.push({
        id: 'supplierPaths',
        parentId: '',
        name: '',
        path: ``,
        isNested: false,
        isDisabled: false,
        type: 'GROUPED_UNNESTED',
        subRoutes: supplierPaths,
      });
    }

    if (user && user.roles.includes('SUPPLIER') && selectAccountType === 'Supplier') {
      const supplierPaths: RouteDetails[] = [];
      supplierPaths.push({
        id: 'settings',
        parentId: 'supplierPaths',
        name: 'Settings',
        path: `/settings`,
        isNested: false,
        isDisabled: isNavDisabled({ section: 'SETTINGS', id: 'settings' }),
        type: '',
        section: 'SETTINGS',
        icon: {
          inActive: <Gear color={COLORS.GREY_400} size={20} />,
          active: <Gear color={COLORS.PRIMARY_500} size={20} weight="fill" />,
        },
      });

      allRoutes.push({
        id: 'supplierPaths',
        parentId: '',
        name: '',
        path: ``,
        isNested: false,
        isDisabled: false,
        type: 'GROUPED_UNNESTED',
        subRoutes: supplierPaths,
      });
    }

    return allRoutes;
  }, [
    location.pathname,
    user?.id,
    user,
    selectAccountType,
    selectedMainBuyerId,
    user?.userMainBuyers,
    supplierOpenDisputesCount,
    isPreviewMode,
    currentSupplier?.invoicingSettings?.dillDoesInvoicing,
  ]);

  useEffect(() => {
    if (location.pathname) {
      const routeCheck = routePaths.find((p) => p.path === location.pathname);

      if (location.search === '?success=true') {
        setOpenConnectSuccessQuickBooksModal(true);
        navigate(buildSupplierPath(routeSupplierId || currentSupplier?.id, '/customers'));
      }
      if (location.search === '?isFromStripeForm=true') {
        dispatch(getSupplierRegistrationStatus({ supplierId: currentSupplier?.id || '' }));
        setBusinessVerifyCustomerModal(true);
      }
      if (location.search === '?success=false') {
        setOpenConnectFailedQuickBooksModal(true);
        navigate(buildSupplierPath(routeSupplierId || currentSupplier?.id, '/customers'));
      }
      if (location.search === '?disconnected=true') {
        setOpenConfirmDisconnectQuickBooksModal(false);
        setOpenDisconnectSuccessModal(true);
        navigate(buildSupplierPath(routeSupplierId || currentSupplier?.id, '/customers'));
      }
      if (location.search === '?disconnected=false') {
        setOpenConfirmDisconnectQuickBooksModal(false);
        setOpenDisconnectFailedModal(true);
        navigate(buildSupplierPath(routeSupplierId || currentSupplier?.id, '/customers'));
      }
    }
    return () => {};
  }, [location.pathname, routePaths, currentSupplier]);

  const handleOpenDropdown = (value: boolean) => {
    setHideTabWhenDropDownOpen(value);
  };

  const handleProfileViewMenuClick = (item: string) => {
    if (item === 'quickBooks') {
      if (
        currentSupplier &&
        ((currentSupplier?.integrationType?.startsWith('CODAT_') &&
          integrationDetails?.codat?.companyId &&
          integrationDetails?.codat?.connectorId) ||
          (currentSupplier?.integrationType?.startsWith('RUTTER_') &&
            integrationDetails?.rutter?.connectionId))
      ) {
        setOpenDisconnectQuickBooksModal(true);
        // setOpenConnectQuickBooksModal(true);
      } else {
        setOpenConnectQuickBooksModal(true);
      }
    }
    if (item === 'logout') {
      localStorage.removeItem('pastPathList');
      localStorage.removeItem('referPath');
      localStorage.removeItem('emailFromLink');
      dispatch(logoutUser());
      dispatch(resetSupplierJobs());
      dispatch(resetSuppliersRootState());
    }
    if (item === 'disconnect') {
      setOpenDisconnectQuickBooksModal(true);
    }
    if (item === 'connectDwolla') {
      setBusinessVerifyCustomerModal(true);
    }
    if (item === 'lienWaiverSettings') {
      setLienWaiverSettingsModal(true);
    }
    if (item == 'inforDistSX') {
      setInforDistSXModal(true);
    }
    if (item === 'p21ManualUpload') {
      setP21ManualUploadSettingsModal(true);
    }
  };

  const handleRetryConnectQuickbooks = async () => {
    await setOpenConnectFailedQuickBooksModal(false);
    handleProfileViewMenuClick('quickBooks');
  };

  const handleDisconnectQuickBooks = () => {
    dispatch(disconnectQuickbooks({ supplierDomainId: currentSupplier?.domainId || '' }));
  };

  useEffect(() => {
    if (quickBooksAuthUri) {
      window.location.href = quickBooksAuthUri;
      clearQuickBooksAuthUri();
    }

    return () => {};
  }, [quickBooksAuthUri]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        accountTypeDropdownRef.current &&
        !accountTypeDropdownRef.current.contains(event.target as Node)
      ) {
        setSelectAccountTypeDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        supplierSelectorDropdownRef.current &&
        !supplierSelectorDropdownRef.current.contains(event.target as Node)
      ) {
        setSupplierSelectorDropdown(false);
        setSupplierSearchQuery('');
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Keep the active supplier in sync with the `/supplier/:supplierId` URL param. A deep
  // link or in-app navigation to a different supplier must drive `currentSupplier` (and
  // the persisted selection) — not the other way round. Guarded to only honor suppliers
  // the user is actually linked to, and to skip when already current (avoids refetch loops).
  useEffect(() => {
    if (
      routeSupplierId &&
      routeSupplierId !== currentSupplier?.id &&
      (user?.linkedSupplierIds ?? []).includes(routeSupplierId)
    ) {
      localStorage.setItem('selectedSupplierId', routeSupplierId);
      dispatch(getCurrentSupplier({ supplierId: routeSupplierId }));
    }
  }, [routeSupplierId, currentSupplier?.id, user?.linkedSupplierIds, dispatch]);

  const handleSelectSupplier = (supplierId: string) => {
    setSupplierSelectorDropdown(false);
    setSupplierSearchQuery('');
    if (!supplierId || supplierId === currentSupplier?.id) {
      return;
    }
    localStorage.setItem('selectedSupplierId', supplierId);
    dispatch(getCurrentSupplier({ supplierId }));

    // `lienReleases` is a top-level route (not under /supplier/:id) whose data is scoped
    // to the current supplier via redux. On switch just collapse any detail path back to
    // the list and keep it un-prefixed.
    if (location.pathname.startsWith('/lienReleases')) {
      navigate('/lienReleases');
      return;
    }

    // Many supplier-scoped pages are tied to a specific record or sub-action of the
    // current supplier (e.g. /customers/:buyerId, /creditApplications/:id,
    // /liens/overview/editLien/:lienId). Those records won't exist under the newly
    // selected supplier, so collapse the path down to the section's list landing rather
    // than carrying a stale id across. Anything deeper than one of these bases (i.e.
    // startsWith `${base}/`) falls back to the base; paths that already are a base, or
    // that don't match any base, are kept as-is.
    const supplierSectionListBasePaths = [
      '/customers',
      '/supplierJobs',
      '/creditApplications',
      '/creditMonitoring',
      '/liens/overview',
      '/preliminaryNotices/overview',
      '/noticeTemplates/templates',
      '/lienTemplates/templates',
      '/creditApplicationRequestTemplates/overview',
    ];
    let targetSubPath = stripSupplierPrefix(location.pathname);
    const matchedBasePath = supplierSectionListBasePaths.find((basePath) =>
      targetSubPath.startsWith(`${basePath}/`)
    );
    if (matchedBasePath) {
      targetSubPath = matchedBasePath;
    }
    navigate(buildSupplierPath(supplierId, targetSubPath));
  };

  const toggleSelectAccountTypeDropdown = () => {
    if (
      (user?.roles.includes('BUYER') || user?.roles.includes('MAIN_BUYER')) &&
      (user?.roles.includes('SUPPLIER') ||
        user?.roles.includes('SUB_SUPPLIER') ||
        user?.roles.includes('CREDIT_APP_SALES'))
    ) {
      setSelectAccountTypeDropdown(!selectAccountTypeDropdown);
    }
  };
  const handleSelectAccountType = (accountType: string) => {
    if (
      accountType === 'Buyer' &&
      (user?.roles.includes('BUYER') || user?.roles.includes('MAIN_BUYER'))
    ) {
      const filtMB = (user?.userMainBuyers || []).filter(
        (mb) => mb?.syncSupplierId !== masonWestSupplierId
      );
      const defaultMainBuyer = sortMainBuyersByLoginSupplier(filtMB)[0];
      if (user?.roles.includes('BUYER')) {
        navigate('/companies');
      } else if (selectedMainBuyerId) {
        navigate(`/buyerLienReleases/${selectedMainBuyerId}/overview`);
      } else if (
        !selectedMainBuyerId &&
        user.userMainBuyers &&
        user.userMainBuyers.length > 0 &&
        defaultMainBuyer
      ) {
        navigate(`/buyerLienReleases/${defaultMainBuyer.id}/overview`);
      }
      localStorage.setItem('selectAccountType', accountType);
      setSelectAccountType(accountType);
    } else if (
      accountType === 'Supplier' &&
      (user?.roles.includes('SUB_SUPPLIER') ||
        user?.roles.includes('SUPPLIER') ||
        user?.roles.includes('CREDIT_APP_SALES'))
    ) {
      if (isCreditAppRestricted(user?.roles)) {
        navigate(buildSupplierPath(routeSupplierId || currentSupplier?.id, '/creditApplications'));
      } else if (user?.roles.includes('AR_SALES') && !user?.roles.includes('AR_ALL')) {
        navigate(buildSupplierPath(routeSupplierId || currentSupplier?.id, '/paymentRequests'));
      } else if (user?.roles.includes('SUPPLIER') || user?.roles.includes('CREDIT_APP_SALES')) {
        navigate(buildSupplierPath(routeSupplierId || currentSupplier?.id, '/customers'));
      } else {
        navigate('/lienReleases');
      }
      localStorage.setItem('selectAccountType', accountType);
      setSelectAccountType(accountType);
    }

    setSelectAccountTypeDropdown(false);
  };
  const currentLocation = useMemo(() => {
    let result = '';
    const splitLocation = location.pathname.split('/');
    if (splitLocation.includes('invoices')) {
      result = 'invoices';
    } else if (splitLocation.includes('mainBuyerDashboard')) {
      result = 'dashboard';
    } else if (splitLocation.includes('statementInvoices')) {
      result = 'statements';
    } else if (splitLocation.includes('paymentPlan')) {
      result = 'payment plans';
    } else {
      result = 'payments';
    }
    if (splitLocation.includes('buyerLienReleases')) {
      result = 'buyerLienReleases';
    }
    return result;
  }, [location.pathname]);

  const handleRefreshAccount = async () => {
    await dispatch(refreshAccounting({ supplierId: currentSupplier?.id || '' }));
    toast.info('Refreshing data from your accounting system...', {
      position: 'top-center',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'colored',
    });
  };

  const onSuccess = async (publicToken: string) => {
    const results = await dispatch(
      processRutterPublicToken({ publicToken, supplierId: currentSupplier?.id || '' })
    );
    if (results && results.type === 'auth/processRutterPublicToken/fulfilled') {
      openDillToast({ type: 'SUCCESS', message: 'Connection success' });
      setOpenConnectSuccessQuickBooksModal(true);
      dispatch(getUserDetails());
    } else {
      openDillToast({ type: 'ERROR', message: 'Error processing connection' });
    }
  };

  const { open } = useRutterLink({
    // publicKey: rutterPublicKey || '',
    publicKey: REACT_APP_RUTTER_PUBLIC_KEY || '',
    onSuccess: onSuccess,
  });

  const pathname = stripSupplierPrefix(location.pathname);
  const pathSplit = pathname.split('/');
  const { sequences: collectionSequencesForHeader } = useAppSelector(
    (state) => state.collectionSequences
  );
  useEffect(() => {
    if (isPreviewMode) {
      setSelectAccountType('Buyer');
      if (previewMainBuyer) {
        dispatch(updateSelectedMainBuyer(previewMainBuyer));
      }
    }

    return () => {
      return;
    };
  }, [isPreviewMode]);

  const isPortalUnderMaintenance =
    selectAccountType === 'Supplier'
      ? !!currentSupplier?.isSupplierUnderMaintenance
      : selectAccountType === 'Buyer'
      ? !!selectedSupplierForBuyer?.isSupplierUnderMaintenance
      : false;

  return (
    <div className="flex flex-col">
      {isPreviewMode && (
        <PreviewModeBanner
          onExit={() => {
            setSelectAccountType('Supplier');
          }}
        />
      )}
      <div className="w-screen h-screen flex flex-row overflow-y-hidden relative">
        <div
          className={twMerge(
            'fixed top-0 left-0 w-full h-full bg-black/50 z-[998] transition-opacity duration-300 lg:hidden',
            !isSidebarCollapsed ? 'block opacity-100' : 'hidden opacity-0'
          )}
          onClick={() => setIsSidebarCollapsed(true)}></div>
        <AddFixedAmountPaymentsModal
          open={isFixedAmountPaymentsModalOpen}
          handleClose={() => {
            setIsFixedAmountPaymentsModalOpen(false);
          }}
        />
        <AppManualImportProgressModal
          open={isAppManualImportProgressModalOpen}
          handleClose={() => {
            setIsAppManualImportProgressModalOpen(false);
          }}
        />
        <AppCustomerSettingsModal
          open={lienWaiverSettingsModal}
          handleClose={() => {
            setLienWaiverSettingsModal(false);
          }}
        />
        <AppManualImportCSVModal
          open={openImportCSVModal}
          handleClose={() => {
            setOpenImportCSVModal(false);
          }}
        />
        <AppDistributionOneConnectionModal
          open={isAppDistributionOneConnectionModalOpen}
          handleClose={() => {
            setIsAppDistributionOneConnectionModalOpen(false);
          }}
        />
        <AppSage100ConnectionModal
          open={isAppSage100ConnectionModalOpen}
          handleClose={() => {
            setIsAppSage100ConnectionModalOpen(false);
          }}
        />
        <AppP21ConnectionModal
          open={isAppP21ConnectionModalOpen}
          handleClose={() => {
            setIsAppP21ConnectionModalOpen(false);
          }}
        />
        <AppEclipseConnectionModal
          open={isAppEclipseConnectionModalOpen}
          handleClose={() => {
            setIsAppEclipseConnectionModalOpen(false);
          }}
        />
        <AppDmsiConnectionModal
          open={isAppDmsiConnectionModalOpen}
          handleClose={() => {
            setIsAppDmsiConnectionModalOpen(false);
          }}
        />
        <AuthorizeQuickbooksConnect
          open={openConnectQuickBooksModal}
          handleClose={() => {
            setOpenConnectQuickBooksModal(false);
          }}
          platformName={platformName}
          modalImage={currentSupplier?.integrationType !== 'QBO' ? platformLogo : null}
          handleAuthorizeButtonClick={() => {
            if (currentSupplier?.integrationType?.startsWith('RUTTER_')) {
              open();
              setOpenConnectQuickBooksModal(false);
            } else if (currentSupplier?.integrationType?.startsWith('DISTRIBUTION_ONE')) {
              setIsAppDistributionOneConnectionModalOpen(true);
              setOpenConnectQuickBooksModal(false);
            } else if (currentSupplier?.integrationType?.startsWith('SAGE_100')) {
              setIsAppSage100ConnectionModalOpen(true);
              setOpenConnectQuickBooksModal(false);
            } else if (currentSupplier?.integrationType?.startsWith('P21')) {
              setIsAppP21ConnectionModalOpen(true);
              setOpenConnectQuickBooksModal(false);
            } else if (currentSupplier?.integrationType === 'ECLIPSE') {
              setIsAppEclipseConnectionModalOpen(true);
              setOpenConnectQuickBooksModal(false);
            } else if (currentSupplier?.integrationType === 'AGILITY_DMSI') {
              setIsAppDmsiConnectionModalOpen(true);
              setOpenConnectQuickBooksModal(false);
            } else {
              dispatch(getQuickBooksAuthUri({ supplierId: currentSupplier?.id || '' }));
            }
          }}
        />
        <ConnectQuickBooksModal
          titleText="Authorization succeeded"
          subTitleText={`Your ${platformName} account is now connected to Dill`}
          buttonText="Back to Dashboard"
          isSuccess={false}
          modalImage={
            currentSupplier?.integrationType !== 'QBO' ? platformLogo : quickBooksConnectSuccessIcon
          }
          open={openConnectSuccessQuickBooksModal}
          handleClose={() => {
            setOpenConnectSuccessQuickBooksModal(false);
          }}
          handleButtonClick={() => {
            setOpenConnectSuccessQuickBooksModal(false);
          }}
        />
        <ConnectQuickBooksModal
          titleText="Authorization failed"
          subTitleText=""
          buttonText="Retry"
          isSuccess={false}
          modalImage={quickBooksConnectFailedIcon}
          open={openConnectFailedQuickBooksModal}
          secondaryButton={true}
          secondaryButtonText="Back to Dashboard"
          handleSecondaryButtonClick={() => {
            setOpenConnectFailedQuickBooksModal(false);
          }}
          handleClose={() => {
            setOpenConnectFailedQuickBooksModal(false);
          }}
          handleButtonClick={handleRetryConnectQuickbooks}
        />
        <ConnectQuickBooksModal
          titleText="Error getting authorization URL"
          subTitleText=""
          buttonText="Retry"
          isSuccess={false}
          secondaryButton={true}
          secondaryButtonText="Back to Dashboard"
          handleSecondaryButtonClick={() => {
            dispatch(clearQuickBooksAuthUri());
          }}
          modalImage={quickBooksConnectWarnIcon}
          open={isGetQuickBooksAuthUrlFailed}
          handleClose={() => {
            dispatch(clearQuickBooksAuthUri());
          }}
          handleButtonClick={handleRetryConnectQuickbooks}
        />
        <ConnectQuickBooksModal
          titleText={
            !isCurrentSupplierIntegrated &&
            currentSupplier &&
            ((currentSupplier?.integrationType?.startsWith('CODAT_') &&
              integrationDetails?.codat?.companyId &&
              integrationDetails?.codat?.connectorId) ||
              (currentSupplier?.integrationType?.startsWith('RUTTER_') &&
                integrationDetails?.rutter?.connectionId))
              ? integrationDetails?.codat &&
                integrationDetails?.codat.currency &&
                integrationDetails?.codat.currency !== 'USD'
                ? `'${integrationDetails?.codat.currency}' currency not supported `
                : 'Finalizing Quickbooks Connection'
              : currentSupplier?.integrationType !== 'QBO'
              ? `${platformName} Connected`
              : 'Quickbooks Connected'
          }
          subTitleText={
            !isCurrentSupplierIntegrated &&
            currentSupplier &&
            ((currentSupplier?.integrationType?.startsWith('CODAT_') &&
              integrationDetails?.codat?.companyId &&
              integrationDetails?.codat?.connectorId) ||
              (currentSupplier?.integrationType?.startsWith('RUTTER_') &&
                integrationDetails?.rutter?.connectionId))
              ? integrationDetails?.codat &&
                integrationDetails?.codat.currency &&
                integrationDetails?.codat.currency !== 'USD'
                ? 'Please update your home currency to “USD.” After doing so, reconnect below and immediately click “Exit” to trigger the sync.'
                : `Your  ${platformName} account is securely connected to Dill but one final step is fetching the expense and vendor accounts which should take a few minutes`
              : `Your  ${platformName} account is securely connected to Dill`
          }
          buttonText={
            currentSupplier &&
            currentSupplier?.integrationType?.startsWith('CODAT_') &&
            integrationDetails?.codat?.companyId &&
            integrationDetails?.codat?.connectorId &&
            integrationDetails?.codat.currency &&
            integrationDetails?.codat.currency !== 'USD'
              ? 'Reconnect'
              : 'Back to Dashboard'
          }
          modalImage={
            currentSupplier?.integrationType !== 'QBO' &&
            !currentSupplier?.integrationType?.startsWith('RUTTER_')
              ? platformLogo
              : quickBooksConnectSuccessIcon
          }
          open={openDisconnectQuickBooksModal}
          secondaryButton={isUserSupplierAdmin({ user, supplier: currentSupplier })}
          secondaryButtonText="Disconnect"
          handleSecondaryButtonClick={() => {
            setOpenDisconnectQuickBooksModal(false);
            setOpenConfirmDisconnectQuickBooksModal(true);
          }}
          handleClose={() => {
            setOpenDisconnectQuickBooksModal(false);
          }}
          handleButtonClick={() => {
            if (
              currentSupplier &&
              currentSupplier?.integrationType?.startsWith('CODAT_') &&
              integrationDetails?.codat?.companyId &&
              integrationDetails?.codat?.connectorId &&
              integrationDetails?.codat.currency &&
              integrationDetails?.codat.currency !== 'USD'
            ) {
              dispatch(getQuickBooksAuthUri({ supplierId: currentSupplier?.id || '' }));
            } else {
              setOpenDisconnectQuickBooksModal(false);
            }
          }}
        />
        <ConnectQuickBooksModal
          titleText={`Are you sure you want to\ndisconnect your\n${platformName}?`}
          subTitleText={`Your ${platformName} account will be disconnected from Dill`}
          buttonText="No , I’m not"
          secondaryButtonText="Yes, I’m sure"
          additionalInfo={
            currentSupplier?.integrationType === 'RUTTER_QBD'
              ? [
                  'You need to remove the web connector from your Quickbooks Desktop',
                  'Go to: File -> App Management -> Update Web Services',
                  'Remove Dill from your list of applications',
                  'You will no longer see your invoices in the "Invoices” tab',
                  'Your customers will no longer see their invoices from you',
                ]
              : [
                  'You will no longer see your invoices in the "Invoices” tab',
                  'Your customers will no longer see their invoices from you',
                ]
          }
          modalImage={
            currentSupplier?.integrationType !== 'QBO' &&
            !currentSupplier?.integrationType?.startsWith('RUTTER_')
              ? platformLogo
              : quickBooksConnectSuccessIcon
          }
          open={openConfirmDisconnectQuickBooksModal}
          secondaryButton={true}
          handleSecondaryButtonClick={async () => {
            handleDisconnectQuickBooks();
          }}
          handleClose={() => {
            setOpenConfirmDisconnectQuickBooksModal(false);
          }}
          handleButtonClick={() => {
            setOpenConfirmDisconnectQuickBooksModal(false);
          }}
        />
        <ConnectQuickBooksModal
          titleText="Successfully disconnected!"
          subTitleText={`Your  ${platformName} account is now disconnected  from Dill.   ${
            currentSupplier && currentSupplier?.integrationType?.startsWith('CODAT_')
              ? 'You may need to click on “remove connection” in your QBD connector if you haven’t already'
              : ''
          }`}
          buttonText="Back to Dashboard"
          modalImage={
            currentSupplier?.integrationType !== 'QBO' ? platformLogo : quickBooksConnectFailedIcon
          }
          open={openDisconnectSuccessModal}
          handleClose={() => {
            setOpenDisconnectSuccessModal(false);
          }}
          handleButtonClick={() => {
            setOpenDisconnectSuccessModal(false);
          }}
        />
        <ConnectQuickBooksModal
          titleText="Failed to disconnect"
          subTitleText=""
          buttonText="Retry"
          isSuccess={false}
          secondaryButton={true}
          secondaryButtonText={'Back to Dashboard'}
          modalImage={
            currentSupplier?.integrationType !== 'QBO' ? platformLogo : quickBooksConnectWarnIcon
          }
          open={openDisconnectFailedModal}
          handleButtonClick={async () => {
            await setOpenDisconnectFailedModal(false);
            setOpenDisconnectQuickBooksModal(true);
          }}
          handleClose={() => {
            setOpenDisconnectFailedModal(false);
          }}
          handleSecondaryButtonClick={() => {
            setOpenDisconnectFailedModal(false);
          }}
        />
        {/* <AppDwollaCustomerDropIn
        open={openDwollaVerifyCustomerModal}
        handleClose={async () => {
          await dispatch(getUserDetails());
          await setOpenDwollaVerifyCustomerModal(false);
          // setBusinessVerifyCustomerModal(true);
        }}
      /> */}
        <AppVerifyBusinessModal
          open={businessVerifyCustomerModal}
          handleClose={() => {
            setBusinessVerifyCustomerModal(false);
          }}
          onVerifyACH={async () => {
            // await setBusinessVerifyCustomerModal(false);
            // await setOpenDwollaVerifyCustomerModal(true);
          }}
          onVerifyBankAccount={async () => {
            // await setBusinessVerifyCustomerModal(false);
            // await setIsAppAddPaymentMethodModalOpen(true);
          }}
        />
        <AppAuthorizeInforDistSXModal
          open={inforDistSXModal}
          handleClose={() => {
            setInforDistSXModal(false);
          }}
          isConnected={isCurrentSupplierIntegrated}
        />
        <AppP21ManualUploadSettingsModal
          open={p21ManualUploadSettingsModal}
          handleClose={() => {
            setP21ManualUploadSettingsModal(false);
          }}
        />
        <section
          className={twMerge(
            'w-[220px] h-screen bg-white py-3 px-3 border-r border-[#eaeff7] flex-shrink-0 flex flex-col z-10',
            'shadow-[2px_0_12px_rgba(55,98,251,0.05)]',
            'max-lg:fixed max-lg:left-0 max-lg:top-0 max-lg:z-[999] max-lg:transition-transform max-lg:duration-300 max-lg:shadow-[4px_0_24px_rgba(0,0,0,0.12)]',
            isSidebarCollapsed ? 'max-lg:-translate-x-full' : 'max-lg:translate-x-0'
          )}>
          <div>
            <div className="flex relative">
              <div className="flex justify-between w-full flex-row gap-1">
                {selectAccountType === 'Buyer' && selectedSupplierForBuyer ? (
                  <div className="flex flex-col justify-center">
                    <img
                      src={selectedSupplierForBuyer?.logo?.url}
                      className="w-auto h-[40px] object-contain"
                      alt="suplier-logo-alt"
                    />
                  </div>
                ) : (
                  <div className="flex items-center">
                    <a href="https://usedill.com/" target="_blank">
                      <img className="h-[30px]" src={dillLogoWithText} />
                    </a>
                  </div>
                )}

                <div className="relative my-1">
                  {user?.roles && user?.roles.length > 0 && (
                    <div ref={accountTypeDropdownRef}>
                      <button
                        className="flex flex-row items-center justify-between gap-1 px-3 py-1.5 w-fit h-7 bg-blue-100 border border-blue-100 rounded-full hover:border-blue-300 transition-all duration-150"
                        onClick={toggleSelectAccountTypeDropdown}>
                        <span className="text-xs font-semibold text-[#3762FB] tracking-tight">
                          {selectAccountType}
                        </span>
                        {(user?.roles.includes('BUYER') || user?.roles.includes('MAIN_BUYER')) &&
                          (user?.roles.includes('SUPPLIER') ||
                            user?.roles.includes('SUB_SUPPLIER') ||
                            user?.roles.includes('CREDIT_APP_SALES')) && (
                            <>
                              {selectAccountTypeDropdown ? (
                                <CaretUp size={16} color={COLORS.PRIMARY_500} weight="bold" />
                              ) : (
                                <CaretDown size={16} color={COLORS.PRIMARY_500} weight="bold" />
                              )}
                            </>
                          )}
                      </button>
                      {selectAccountTypeDropdown && (
                        <button
                          className="absolute flex flex-row items-center justify-between gap-1 px-3 py-1.5 w-[90px] h-7 bg-white shadow-md rounded-lg z-10"
                          onClick={() =>
                            handleSelectAccountType(
                              `${selectAccountType === 'Buyer' ? 'Supplier' : 'Buyer'}`
                            )
                          }>
                          <p className="text-xs font-semibold text-black tracking-tight hover:text-[#3762fb] transition-colors">
                            {`${selectAccountType === 'Buyer' ? 'Supplier' : 'Buyer'}`}
                          </p>
                        </button>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
            {selectAccountType === 'Supplier' && userSuppliers.length > 1 && (
              <div className="relative mt-2" ref={supplierSelectorDropdownRef}>
                <button
                  className="flex flex-row items-center justify-between gap-1 px-3 py-1.5 w-full h-8 bg-blue-50 border border-blue-100 rounded-lg hover:border-blue-300 transition-all duration-150"
                  onClick={() => {
                    setSupplierSelectorDropdown(!supplierSelectorDropdown);
                    setSupplierSearchQuery('');
                  }}>
                  <span className="text-xs font-semibold text-[#3762FB] tracking-tight truncate">
                    {currentSupplier?.name || 'Select supplier'}
                  </span>
                  {supplierSelectorDropdown ? (
                    <CaretUp size={16} color={COLORS.PRIMARY_500} weight="bold" />
                  ) : (
                    <CaretDown size={16} color={COLORS.PRIMARY_500} weight="bold" />
                  )}
                </button>
                {supplierSelectorDropdown && (
                  <div className="absolute left-0 right-0 mt-1 flex flex-col bg-white shadow-md rounded-lg z-20 py-0 max-h-[260px] overflow-y-auto">
                    <div className="sticky top-0 bg-white px-2 pt-1 pb-2">
                      <div className="flex flex-row items-center gap-2 px-2 h-8 bg-blue-50 border border-blue-100 rounded-lg focus-within:border-blue-300 transition-all duration-150">
                        <MagnifyingGlass size={14} color={COLORS.PRIMARY_500} weight="bold" />
                        <input
                          type="text"
                          autoFocus
                          value={supplierSearchQuery}
                          onChange={(e) => setSupplierSearchQuery(e.target.value)}
                          placeholder="Search supplier"
                          className="flex-1 bg-transparent text-xs font-medium text-black tracking-tight placeholder:text-gray-400 outline-none"
                        />
                      </div>
                    </div>
                    {userSuppliers
                      .filter((supplier) =>
                        supplier.name
                          ?.toLowerCase()
                          .includes(supplierSearchQuery.trim().toLowerCase())
                      )
                      .map((supplier) => (
                        <button
                          key={supplier.id}
                          className={twMerge(
                            'flex flex-row items-center gap-2 px-3 py-2 w-full text-left hover:bg-blue-50 transition-colors',
                            supplier.id === currentSupplier?.id ? 'bg-blue-50' : ''
                          )}
                          onClick={() => handleSelectSupplier(supplier.id)}>
                          {supplier?.logo?.url && (
                            <img
                              src={supplier.logo.url}
                              className="w-5 h-5 object-contain flex-shrink-0"
                              alt="supplier-logo"
                            />
                          )}
                          <p
                            className={twMerge(
                              'text-xs font-medium text-black tracking-tight truncate',
                              supplier.id === currentSupplier?.id
                                ? 'text-[#3762fb] font-semibold'
                                : ''
                            )}>
                            {supplier.name}
                          </p>
                        </button>
                      ))}
                    {userSuppliers.filter((supplier) =>
                      supplier.name
                        ?.toLowerCase()
                        .includes(supplierSearchQuery.trim().toLowerCase())
                    ).length === 0 && (
                      <p className="px-3 py-2 text-xs font-medium text-gray-400 tracking-tight">
                        No suppliers found
                      </p>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>

          <div
            className={twMerge(
              'flex flex-col  justify-between',
              selectAccountType === 'Supplier' ? 'h-[90vh]' : 'h-[98vh]'
            )}>
            <div className="flex flex-col mt-[44px] relative overflow-y-scroll overflow-x-clip px-0 py-4">
              {/* Render other route types that don't have sections */}
              {nestedRoutePaths.map((route, routeIndex) => {
                // Skip routes that are already rendered in sections above
                if (route.type === 'GROUPED_UNNESTED' || (route.type === '' && route.section)) {
                  return null;
                }

                if (route.type === 'STANDALONE' && !hideTabWhenDropDownOpen) {
                  return (
                    <div key={routeIndex + 'ee'} className="">
                      <div className="">
                        {pathSplit[1] &&
                          route.subRoutes?.map((subRoute, j) => {
                            return (
                              <Link
                                key={j + 'standalone-routes-oi'}
                                to={subRoute.path}
                                className={twMerge(
                                  'flex h-9 items-center px-2 rounded-lg transition-all duration-150 group',
                                  location.pathname.startsWith(subRoute.path)
                                    ? 'bg-blue-100/70 border-[#3762FB] shadow-sm'
                                    : 'hover:bg-blue-50 border-transparent'
                                )}
                                onClick={() => {
                                  setIsSidebarCollapsed(true);
                                }}>
                                {pathSplit.length > 1 &&
                                  subRoute.id === pathSplit[3] &&
                                  subRoute?.icon &&
                                  subRoute?.icon.active}
                                {pathSplit.length > 1 &&
                                  subRoute.id !== pathSplit[3] &&
                                  subRoute?.icon &&
                                  subRoute?.icon.inActive}
                                <p
                                  className={
                                    'text-sm ml-3.5 whitespace-nowrap ' +
                                    (location.pathname.startsWith(subRoute.path)
                                      ? 'PRIMARY_500-CLR'
                                      : 'GREY_500-CLR font-medium group-hover:text-gray-900')
                                  }>
                                  {subRoute.name.substring(0, 9)}
                                  {subRoute.name.length > 9 && '...'}
                                </p>
                              </Link>
                            );
                          })}
                      </div>
                    </div>
                  );
                }
                if (route.type === 'EXPANDABLE' && !hideTabWhenDropDownOpen) {
                  return (
                    <div key={routeIndex + 'ee'} className="">
                      <Link
                        to={route.path}
                        className={twMerge(
                          'flex h-9 items-center px-2 rounded-lg justify-between rounded-lg transition-all duration-150 group',
                          pathSplit.length > 1 && route.id === pathSplit[1]
                            ? ' bg-blue-100/70 border-[#3762FB] shadow-sm'
                            : ' hover:bg-blue-50 border-transparent'
                        )}>
                        <div className="flex items-center">
                          {pathSplit.length > 1 &&
                            route.id === pathSplit[1] &&
                            route?.icon &&
                            // <img src={route?.icon.imageActive} />
                            // <UserCircle />
                            route?.icon.active}
                          {pathSplit.length > 1 &&
                            route.id !== pathSplit[1] &&
                            route?.icon &&
                            // <img src={route?.icon.image} />
                            // <UserCircle />
                            route?.icon.inActive}
                          <p
                            className={
                              ' text-sm ml-3.5 ' +
                              (pathSplit.length > 1 && route.id === pathSplit[1]
                                ? 'PRIMARY_500-CLR'
                                : 'GREY_500-CLR font-medium group-hover:text-gray-900')
                            }>
                            {route.name.substring(0, 17)}
                            {route.name.length > 17 && '...'}
                          </p>
                        </div>

                        {route.path !== location.pathname && <CaretDown size={16} />}
                        {route.path === location.pathname && <CaretUp size={16} />}
                      </Link>
                      <div className="">
                        {pathSplit[1] &&
                          route.subRoutes
                            ?.filter(
                              (subRoute) => subRoute.parentId && pathSplit[1] === subRoute?.parentId
                            )
                            ?.map((subRoute, j) => {
                              const subRoutePathSplit = subRoute.path.split('/');
                              return (
                                <Link
                                  key={j + 'oi'}
                                  to={subRoute.path}
                                  className={twMerge(
                                    'flex h-7 ml-5 mt-0.5 items-center px-2 rounded-lg transition-all duration-150 group',
                                    location.pathname.startsWith(subRoute.path)
                                      ? 'bg-blue-100/70 border-[#3762FB] shadow-sm'
                                      : 'hover:bg-blue-50 border-transparent'
                                  )}
                                  onClick={() => {
                                    setIsSidebarCollapsed(true);
                                  }}>
                                  {pathSplit.length > 1 &&
                                    subRoute.id === pathSplit[3] &&
                                    subRoute?.icon &&
                                    // <img src={route?.icon.imageActive} />
                                    // <UserCircle />
                                    subRoute?.icon.active}
                                  {pathSplit.length > 1 &&
                                    subRoute.id !== pathSplit[3] &&
                                    subRoute?.icon &&
                                    // <img src={route?.icon.image} />
                                    // <UserCircle />
                                    subRoute?.icon.inActive}
                                  <p
                                    className={
                                      ' text-sm ml-3.5 whitespace-nowrap ' +
                                      (location.pathname.startsWith(subRoute.path)
                                        ? 'PRIMARY_500-CLR'
                                        : 'GREY_500-CLR font-medium group-hover:text-gray-900')
                                    }>
                                    {subRoute.name.substring(0, 9)}
                                    {subRoute.name.length > 9 && '...'}
                                  </p>
                                </Link>
                              );
                            })}
                      </div>
                    </div>
                  );
                }
                if (route.type === 'DROP_DOWN_SELECT') {
                  return (
                    <div key={route.id} className="relative">
                      <p className="py-2">{route.name}</p>
                      <Dropdown
                        onOpenDropdown={handleOpenDropdown}
                        subRoutes={route?.subRoutes || []}
                        pathSplit={pathSplit}
                        closeSideNav={() => {
                          setIsSidebarCollapsed(true);
                        }}
                      />
                    </div>
                  );
                }
              })}
              {(() => {
                // Group routes by section
                const routesBySection: { [key: string]: RouteDetails[] } = {};
                const sectionOrder = [
                  'CREDIT',
                  'AR + ONLINE PAYMENTS',
                  'AI CASH APPLICATION',
                  'LIENS',
                  'REPORT',
                  'SETTINGS',
                ];

                nestedRoutePaths.forEach((route) => {
                  if (route.type === 'GROUPED_UNNESTED' && route.subRoutes) {
                    route.subRoutes.forEach((subRoute) => {
                      const section = subRoute.section || 'Other';
                      if (!routesBySection[section]) {
                        routesBySection[section] = [];
                      }
                      routesBySection[section].push({
                        ...subRoute,
                        isDisabled: route.isDisabled || subRoute.isDisabled,
                      });
                    });
                  } else if (route.type === '' || route.type === 'EXPANDABLE') {
                    const section = route.section || 'Other';
                    if (!routesBySection[section]) {
                      routesBySection[section] = [];
                    }
                    routesBySection[section].push(route);
                  }
                });

                return sectionOrder.map((section) => {
                  const sectionRoutes = routesBySection[section];
                  if (!sectionRoutes || sectionRoutes.length === 0) return null;

                  return (
                    <div key={section} className="mb-6 relative">
                      <p
                        className="text-[10px] font-bold mb-2 px-3 uppercase"
                        style={{ color: '#94A3B8', letterSpacing: '0.1em' }}>
                        {section}
                      </p>
                      <div className="flex flex-col gap-0">
                        {sectionRoutes.map((subRoute, j) => {
                          let locationPathId;
                          if (selectedMainBuyerId) {
                            if (selectedMainBuyerId === pathSplit[2]) {
                              locationPathId = pathSplit[3];
                            } else {
                              locationPathId = pathSplit[2];
                            }
                          } else {
                            if (pathname.startsWith('/cashApplication/')) {
                              locationPathId = pathname;
                            } else {
                              locationPathId = pathSplit[1];
                            }
                          }
                          const isActive = pathSplit.length > 1 && subRoute.id === locationPathId;

                          return (
                            <div key={j + 'route'} className="">
                              <Link
                                to={
                                  // `lienReleases` is a top-level route (not under
                                  // /supplier/:id), so it must not be supplier-prefixed.
                                  subRoute.path.startsWith('/lienReleases')
                                    ? subRoute.path
                                    : buildSupplierPath(
                                        routeSupplierId || currentSupplier?.id,
                                        subRoute.path
                                      )
                                }
                                className={twMerge(
                                  'flex h-9 items-center px-2 rounded-lg transition-all duration-150 group',
                                  isActive
                                    ? 'bg-blue-100/70 border-[#3762FB] shadow-sm'
                                    : subRoute.isDisabled
                                    ? 'border-transparent'
                                    : 'hover:bg-blue-50 border-transparent',
                                  subRoute.isDisabled ? 'opacity-60' : '',
                                  subRoute.isDisabled ? 'cursor-not-allowed' : 'cursor-pointer'
                                )}
                                onClick={(e) => {
                                  if (subRoute.isDisabled) {
                                    e.preventDefault();
                                    return;
                                  }
                                  setIsSidebarCollapsed(true);
                                }}>
                                <div className="flex items-center gap-3 w-full">
                                  <div className="flex-shrink-0">
                                    {isActive && subRoute?.icon?.active}
                                    {!isActive && subRoute?.icon?.inActive}
                                  </div>
                                  <p
                                    className={twMerge(
                                      'text-sm truncate',
                                      isActive
                                        ? 'PRIMARY_500-CLR'
                                        : subRoute.isDisabled
                                        ? 'GREY_500-CLR font-medium'
                                        : 'GREY_500-CLR font-medium group-hover:text-gray-900'
                                    )}>
                                    {subRoute.name}
                                  </p>
                                  {subRoute.notification && subRoute.notification.data && (
                                    <div className="min-w-[18px] h-[18px] px-1 rounded-full bg-gradient-to-r from-orange-400 to-red-400 shadow-sm flex items-center justify-center">
                                      <span className="text-2xs font-semibold text-white">
                                        {subRoute.notification.data}
                                      </span>
                                    </div>
                                  )}
                                  {subRoute.isDisabled && (
                                    <Lock
                                      data-tooltip-id={'locked_user_feature'}
                                      color={COLORS.ERROR_500}
                                      size={12}
                                      className="ml-auto flex-shrink-0"
                                    />
                                  )}
                                </div>
                              </Link>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                });
              })()}
            </div>

            <div className="flex flex-wrap whitespace-pre-wrap w-full self-end justify-self-end pb-6">
              <div className="mb-4 w-full rounded-xl bg-slate-50 border border-slate-100 p-3">
                {user?.roles.includes('SUPPLIER') &&
                  isCurrentSupplierIntegrated &&
                  selectAccountType === 'Supplier' &&
                  currentSupplier?.integrationType?.startsWith('CODAT_') && (
                    <AppButton
                      text={'Refresh Accounting'}
                      type="TERTIARY"
                      onClick={handleRefreshAccount}
                      icon={<RefreshCcw color={COLORS.PRIMARY_500} size={15} />}
                      buttonStyles={{ width: '100%', marginBottom: '8px' }}
                    />
                  )}
                {selectAccountType === 'Buyer' && (
                  <div className="flex gap-2 text-[#3762FB] bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg w-full items-center p-2 border border-blue-100 mb-2">
                    <div className="flex-shrink-0">
                      <ShieldCheck size={16} weight="fill" />
                    </div>
                    <p className="text-[11px] font-semibold">
                      End-to-End Encrypted Secure Payments
                    </p>
                  </div>
                )}
                <p className="text-[11px] text-gray-500 font-normal leading-snug">
                  Need help? We respond in minutes.
                </p>
                <div className="flex items-center gap-1 mt-1.5">
                  <span className="font-semibold text-[10px] whitespace-nowrap text-gray-600">
                    Dill Email:
                  </span>
                  <a
                    href="mailto:support@usedill.com"
                    target="_blank"
                    className="text-[10px] text-[#3762FB] truncate hover:underline">
                    support@usedill.com
                  </a>
                </div>
                <div className="flex items-center gap-1 mt-1">
                  <span className="font-semibold text-[10px] whitespace-nowrap text-gray-600">
                    Dill Phone:
                  </span>
                  <span className="text-[10px] text-[#3762FB]">(628) 304-0931</span>
                </div>
                {selectAccountType === 'Buyer' && (
                  <>
                    {selectedSupplierForBuyer?.email && (
                      <div className="flex items-center gap-1 mt-1">
                        <span className="font-semibold text-[10px] whitespace-nowrap text-gray-600">
                          Email:
                        </span>
                        <a
                          href={`mailto:${selectedSupplierForBuyer.email}`}
                          target="_blank"
                          className="text-[10px] text-[#3762FB] truncate hover:underline">
                          {selectedSupplierForBuyer.email}
                        </a>
                      </div>
                    )}
                    {selectedSupplierForBuyer?.phoneNumber && (
                      <div className="flex items-center gap-1 mt-1">
                        <span className="font-semibold text-[10px] whitespace-nowrap text-gray-600">
                          Phone:
                        </span>
                        <span className="text-[10px] text-[#3762FB]">
                          {selectedSupplierForBuyer.phoneNumber}
                        </span>
                      </div>
                    )}
                  </>
                )}
              </div>
              {user && (
                <div className="relative inline-flex">
                  <DillButton
                    label="Help"
                    variant="ghost-yellow"
                    icon={<HelpCircle size={15} />}
                    onClick={() => navigate(`/help`)}
                  />
                  {selectAccountType === 'Buyer' && (
                    <span className="absolute -top-1.5 -right-1.5 flex items-center justify-center min-w-[16px] h-[16px] px-1 rounded-full bg-[#EF4444] text-white text-[10px] font-bold leading-none z-10">
                      1
                    </span>
                  )}
                </div>
              )}
            </div>
          </div>
        </section>
        <section className="flex-1 min-w-0 h-screen bg-[#f5f7fb] overflow-y-auto max-lg:w-full flex flex-col">
          <div className="flex justify-between bg-white px-4 sm:px-6 border-b border-gray-100 items-center font-bold text-[#101218] text-sm md:text-base h-[56px] sticky top-0 z-50 shadow-[0_1px_6px_rgba(55,98,251,0.06)] flex-shrink-0">
            <div className="flex-1 min-w-0 flex flex-row items-center gap-2">
              {isSidebarCollapsed && (
                <button
                  className="flex lg:hidden items-center justify-center bg-white border border-[#e4eaf1] rounded-lg p-1.5 cursor-pointer shadow-sm hover:bg-slate-50 hover:border-slate-300 mr-1"
                  onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)}>
                  <Menu size={18} className="text-slate-500" />
                </button>
              )}
              {pathname.startsWith('/creditApplicationRequestTemplates') && (
                <div>
                  {pathSplit.length === 3 && (
                    <h3 className=" ">Credit / COD Application Templates</h3>
                  )}
                  {pathSplit.length > 3 && (
                    <button
                      className={'flex ' + (pathSplit.length > 2 ? 'cursor-pointer' : '')}
                      onClick={() => {
                        if (pathSplit.length > 2) {
                          navigate(
                            buildSupplierPath(
                              routeSupplierId,
                              '/creditApplicationRequestTemplates/overview'
                            )
                          );
                        }
                      }}
                      disabled={!(pathSplit.length > 3)}>
                      {pathSplit.length > 3 && <ChevronLeft />}
                      <h3 className="  ml-3 ">
                        {pathSplit.includes('addCreditApplicationRequestTemplate')
                          ? 'Add Credit/COD Application Template'
                          : 'Edit Credit/COD Application Template'}
                      </h3>
                    </button>
                  )}
                </div>
              )}
              {pathname.startsWith('/creditMonitoring') && (
                <div>
                  {pathSplit.length === 2 && <h3 className="">Credit Monitoring</h3>}
                  {pathSplit.length > 2 && (
                    <button
                      className={'flex ' + (pathSplit.length > 2 ? 'cursor-pointer' : '')}
                      onClick={() => {
                        if (pathSplit.length > 2) {
                          navigate(
                            buildSupplierPath(
                              routeSupplierId || currentSupplier?.id,
                              '/creditMonitoring'
                            )
                          );
                        }
                      }}
                      disabled={!(pathSplit.length > 2)}>
                      {pathSplit.length > 2 && <ChevronLeft />}
                      <h3 className="ml-3 ">Credit Monitoring</h3>
                    </button>
                  )}
                </div>
              )}
              {pathname.startsWith('/creditApplications') && (
                <div>
                  {pathSplit.length === 2 && <h3 className="">Credit / COD Applications</h3>}
                  {pathSplit.length > 2 && (
                    <button
                      className={'flex ' + (pathSplit.length > 2 ? 'cursor-pointer' : '')}
                      onClick={() => {
                        if (pathSplit.length > 2) {
                          navigate(
                            buildSupplierPath(
                              routeSupplierId || currentSupplier?.id,
                              '/creditApplications'
                            )
                          );
                        }
                      }}
                      disabled={!(pathSplit.length > 2)}>
                      {pathSplit.length > 2 && <ChevronLeft />}
                      <h3 className="ml-3 ">
                        {pathSplit.includes('manualUploadCreditApplication')
                          ? 'Upload Application'
                          : pathSplit.includes('manualAddCreditApplication')
                          ? 'Manual Add Application'
                          : pathSplit.includes('internalForms')
                          ? pathSplit.length > 3
                            ? 'Internal Form Details'
                            : 'Internal Forms'
                          : 'Application Details'}
                      </h3>
                    </button>
                  )}
                </div>
              )}
              {pathname.startsWith('/dashboardCreditApplications') && (
                <div className="flex justify-between items-center pr-4">
                  <h3 className="">Credit Applications Dashboard</h3>
                </div>
              )}
              {pathname.startsWith('/dashboardPayments') && (
                <div className="flex justify-between items-center pr-4">
                  <h3 className="">Payments Dashboard</h3>
                </div>
              )}
              {pathname.startsWith('/customers') && (
                <div className="">
                  {pathSplit.length === 2 && <h3 className=" ">Customers</h3>}
                  {pathSplit.length > 2 && (
                    <button
                      className={'flex ' + (pathSplit.length > 2 ? 'cursor-pointer' : '')}
                      onClick={() => {
                        if (pathSplit.length > 2) {
                          navigate(
                            buildSupplierPath(routeSupplierId || currentSupplier?.id, '/customers')
                          );
                        }
                      }}
                      disabled={!(pathSplit.length > 2)}>
                      {pathSplit.length > 2 && <ChevronLeft />}
                      <h3 className="ml-3 ">Customer Details</h3>
                    </button>
                  )}
                </div>
              )}
              {pathname.startsWith('/invoices') && (
                <div className="flex justify-between items-center pr-4">
                  <h3 className="">Invoices</h3>
                </div>
              )}
              {pathname.startsWith('/disputes') && (
                <div className="flex justify-between items-center pr-4">
                  <h3 className="">Disputes</h3>
                </div>
              )}{' '}
              {pathname.startsWith('/promiseToPays') && (
                <div className="flex justify-between items-center pr-4">
                  <h3 className="">Promise to Pays</h3>
                </div>
              )}
              {pathname.startsWith('/collectionSequencesAndTriggers') && (
                <div className="flex justify-between items-center pr-4">
                  {pathSplit.length > 2 ? (
                    <button
                      className="flex cursor-pointer"
                      onClick={() =>
                        navigate(
                          buildSupplierPath(
                            routeSupplierId || currentSupplier?.id,
                            '/collectionSequencesAndTriggers'
                          )
                        )
                      }>
                      <ChevronLeft />
                      <h3 className="ml-3">
                        {collectionSequencesForHeader.find((s) => s.id === pathSplit[2])?.name ||
                          'Sequence'}
                      </h3>
                    </button>
                  ) : (
                    <h3 className="">Collection Workflows</h3>
                  )}
                </div>
              )}
              {pathname.startsWith('/invoiceDelivery') && (
                <div className="flex justify-between items-center pr-4">
                  <h3 className="">Invoice Delivery</h3>
                </div>
              )}
              {pathname.startsWith('/payments') && (
                <div>
                  <h3 className="">Payments</h3>
                </div>
              )}
              {pathname.startsWith('/paymentRequests') && (
                <div>
                  <h3 className="">Payment Requests</h3>
                </div>
              )}
              {pathname.startsWith('/lienReleases') && (
                <div>
                  {pathSplit.length > 2 && (
                    <button
                      className={'flex ' + (pathSplit.length > 2 ? 'cursor-pointer' : '')}
                      onClick={() => {
                        if (pathSplit.length > 2) {
                          navigate('/lienReleases');
                        }
                      }}
                      disabled={!(pathSplit.length > 2)}>
                      {pathSplit.length > 2 && <ChevronLeft />}
                      <h3 className="ml-3 ">Lien Waiver</h3>
                      {selectedLiensRelease && (
                        <h3 className="ml-1 capitalize">
                          {`  -  ${selectedLiensRelease.buyer?.name ?? ''}`}
                        </h3>
                      )}
                      {/* {selectedLiensRelease && (
                      <h3 className="font-bold TEXT_PRIMARY-CLR  ml-1 capitalize">
                        {`  -  ${
                          moment(selectedLiensRelease.throughDate).format('MM/DD/YYYY') ?? ''
                        }`}
                      </h3>
                    )} */}
                      {selectedLiensRelease && (
                        <h3 className="ml-1 capitalize ">
                          {`  -  ${selectedLiensRelease.job?.name ?? ''}`}
                        </h3>
                      )}
                    </button>
                  )}
                  {pathSplit.length < 3 && <h3 className="">Lien Waivers</h3>}
                </div>
              )}
              {pathname.startsWith('/preliminaryNotices') && (
                <div>
                  {pathSplit.length > 3 && (
                    <button
                      className={'flex ' + (pathSplit.length > 2 ? 'cursor-pointer' : '')}
                      onClick={() => {
                        if (pathSplit.length > 2) {
                          navigate(
                            buildSupplierPath(
                              routeSupplierId || currentSupplier?.id,
                              '/preliminaryNotices/overview'
                            )
                          );
                        }
                      }}
                      disabled={!(pathSplit.length > 2)}>
                      {pathSplit.length > 2 && <ChevronLeft />}
                      <h3 className="ml-3 ">
                        {`${
                          pathSplit.length > 4
                            ? 'Edit Preliminary Notice'
                            : pathSplit.includes('manualAddPreliminaryNotice')
                            ? 'Manual Add Preliminary Notice'
                            : 'Request Preliminary Notice'
                        }`}
                      </h3>
                    </button>
                  )}
                  {pathSplit.length < 4 && <h3 className="">Preliminary Notices</h3>}
                </div>
              )}
              {pathname.startsWith('/liens') && (
                <div>
                  {pathSplit.length > 3 && (
                    <button
                      className={'flex ' + (pathSplit.length > 2 ? 'cursor-pointer' : '')}
                      onClick={() => {
                        if (pathSplit.length > 2) {
                          navigate(
                            buildSupplierPath(
                              routeSupplierId || currentSupplier?.id,
                              '/liens/overview'
                            )
                          );
                        }
                      }}
                      disabled={!(pathSplit.length > 2)}>
                      {pathSplit.length > 2 && <ChevronLeft />}
                      <h3 className="ml-3 ">
                        {`${pathSplit.length > 4 ? 'Edit Lien' : 'File Lien'}`}
                      </h3>
                    </button>
                  )}
                  {pathSplit.length < 4 && <h3 className="">Liens</h3>}
                </div>
              )}
              {pathname.startsWith('/noticeTemplates') && (
                <div>
                  {pathSplit.length > 3 && (
                    <button
                      className={'flex ' + (pathSplit.length > 2 ? 'cursor-pointer' : '')}
                      onClick={() => {
                        if (pathSplit.length > 2) {
                          navigate(
                            buildSupplierPath(
                              routeSupplierId || currentSupplier?.id,
                              '/noticeTemplates/templates'
                            )
                          );
                        }
                      }}
                      disabled={!(pathSplit.length > 2)}>
                      {pathSplit.length > 2 && <ChevronLeft />}
                      <h3 className="ml-3 ">Add Preliminary Notices Template</h3>
                    </button>
                  )}
                  {pathSplit.length < 4 && <h3 className="">Preliminary Notices Templates</h3>}
                </div>
              )}
              {pathname.startsWith('/noticeTemplateFields') && (
                <div>
                  <h3 className="">Add Notice Template Fields</h3>
                </div>
              )}
              {pathname.startsWith('/lienTemplates') && (
                <div>
                  {pathSplit.length > 3 && (
                    <button
                      className={'flex ' + (pathSplit.length > 2 ? 'cursor-pointer' : '')}
                      onClick={() => {
                        if (pathSplit.length > 2) {
                          navigate(
                            buildSupplierPath(
                              routeSupplierId || currentSupplier?.id,
                              '/lienTemplates/templates'
                            )
                          );
                        }
                      }}
                      disabled={!(pathSplit.length > 2)}>
                      {pathSplit.length > 2 && <ChevronLeft />}
                      <h3 className="ml-3 ">Add Lien Template</h3>
                    </button>
                  )}
                  {pathSplit.length < 4 && <h3 className="">Lien Templates</h3>}
                </div>
              )}
              {pathname.startsWith('/lienTemplateFields') && (
                <div>
                  <h3 className="">Add Lien Template Fields</h3>
                </div>
              )}
              {pathname.startsWith('/tradeReferencesPool') && (
                <div>
                  <h3 className="">Trade Reference Pool</h3>
                </div>
              )}
              {pathname.startsWith('/approvalWorkflows') && (
                <div>
                  <h3 className="">Approval Workflows</h3>
                </div>
              )}
              {pathname.startsWith('/supplierJobs') && (
                <div>
                  {pathSplit.length === 2 && <h3 className="">Jobs</h3>}
                  {pathSplit.length > 2 && (
                    <button
                      className={'flex ' + (pathSplit.length > 2 ? 'cursor-pointer' : '')}
                      onClick={() => {
                        if (pathSplit.length > 2) {
                          navigate(
                            buildSupplierPath(
                              routeSupplierId || currentSupplier?.id,
                              '/supplierJobs'
                            )
                          );
                        }
                      }}
                      disabled={!(pathSplit.length > 2)}>
                      {pathSplit.length > 2 && <ChevronLeft />}
                      <h3 className="ml-3 ">Job Details</h3>
                    </button>
                  )}
                </div>
              )}
              {location.pathname.startsWith(
                `/buyerLienReleases/${selectedMainBuyerId}/overview`
              ) && (
                <div>
                  {location.pathname.length ===
                    `/buyerLienReleases/${selectedMainBuyerId}/overview`.length && (
                    <h3 className="">Lien Waivers</h3>
                  )}
                  {location.pathname.length >
                    `/buyerLienReleases/${selectedMainBuyerId}/overview`.length && (
                    <button
                      className={'flex cursor-pointer'}
                      onClick={() => {
                        navigate(`/buyerLienReleases/${selectedMainBuyerId}/overview`);
                      }}>
                      <ChevronLeft />
                      <h3 className=" ml-3 ">
                        {location.pathname.split('/').includes('addLienRelease')
                          ? 'Request Release'
                          : location.pathname.split('/').includes('manualAddLienRelease')
                          ? 'Manual Add Signed Release'
                          : 'Edit Release'}
                      </h3>
                    </button>
                  )}
                </div>
              )}
              {location.pathname.startsWith(
                `/buyerLienReleases/${selectedMainBuyerId}/lienReleasesSupplier`
              ) && (
                <div>
                  <h3 className="">Suppliers</h3>
                </div>
              )}
              {location.pathname.startsWith(
                `/buyerLienReleases/${selectedMainBuyerId}/lienReleasesJobs`
              ) && (
                <div className="flex">
                  <button
                    className={
                      'flex ' +
                      (location.pathname.length >
                      `/buyerLienReleases/${selectedMainBuyerId}/lienReleasesJobs`.length
                        ? 'cursor-pointer'
                        : '')
                    }
                    onClick={() => {
                      if (location.pathname.split('/').length === 5) {
                        navigate(`/buyerLienReleases/${selectedMainBuyerId}/lienReleasesJobs`);
                      } else if (
                        location.pathname.split('/').length === 6 ||
                        location.pathname.split('/').length === 7
                      ) {
                        navigate(
                          `/buyerLienReleases/${selectedMainBuyerId}/lienReleasesJobs/${selectedJob?.id}`
                        );
                      }
                    }}
                    disabled={!(location.pathname.split('/').length > 4)}>
                    {location.pathname.split('/').length > 4 && <ChevronLeft />}
                    <h3 className="">
                      {location.pathname.length ===
                      `/buyerLienReleases/${selectedMainBuyerId}/lienReleasesJobs`.length
                        ? 'Jobs'
                        : location.pathname.includes('addRelease')
                        ? 'Request Release'
                        : location.pathname.includes('editRelease')
                        ? 'Edit Job Release'
                        : `# ${selectedJob?.number ?? ''} ${selectedJob?.name ?? ''}`}
                    </h3>
                  </button>
                </div>
              )}
              {location.pathname.startsWith(
                `/buyerLienReleases/${selectedMainBuyerId}/templates`
              ) && (
                <div className="flex">
                  {/* <h3 className="font-bold TEXT_PRIMARY-CLR  ">Templates</h3> */}

                  {selectedMainBuyer !== null && (
                    <button
                      className={
                        'flex ' +
                        (location.pathname.length >
                        `/buyerLienReleases/${selectedMainBuyerId}/templates`.length
                          ? 'cursor-pointer'
                          : '')
                      }
                      onClick={() => {
                        if (
                          location.pathname.length >
                          `/buyerLienReleases/${selectedMainBuyerId}/templates`.length
                        ) {
                          navigate(`/buyerLienReleases/${selectedMainBuyerId}/templates`);
                        }
                      }}
                      disabled={
                        location.pathname.length ===
                        `/buyerLienReleases/${selectedMainBuyerId}/templates`.length
                      }>
                      {location.pathname.length >
                        `/buyerLienReleases/${selectedMainBuyerId}/templates`.length && (
                        <ChevronLeft />
                      )}
                      <h3 className="ml-1 capitalize ">Templates</h3>
                    </button>
                  )}
                </div>
              )}
              {location.pathname.startsWith(`/buyerLienReleases/templateFields`) && (
                <div>
                  <h3 className="">Add Template With Fields</h3>
                </div>
              )}
              {pathname.startsWith('/help') && (
                <div>
                  <h3 className="">Help</h3>
                </div>
              )}
              {pathname.startsWith('/salesReceipts') && (
                <div>
                  <h3 className="">Sales Receipts</h3>
                </div>
              )}
              {location.pathname.startsWith('/companies') && (
                <div className="flex">
                  {selectedMainBuyer !== null && (
                    <button
                      className={
                        'flex ' + (location.pathname.split('/').length > 4 ? 'cursor-pointer' : '')
                      }
                      onClick={() => {
                        if (location.pathname.split('/').length > 4) {
                          navigate(`/companies/${selectedMainBuyerId}/invoices`);
                        }
                      }}
                      disabled={!(location.pathname.split('/').length > 4)}>
                      {params && params.supplierDomainId && <ChevronLeft />}
                      {!params.supplierDomainId && (
                        <h3 className="ml-1 capitalize text-nowrap sm:text-wrap text-start truncate w-[60vw] sm:w-auto ">
                          {`${selectedMainBuyer?.name.toLocaleLowerCase()} ${currentLocation}`}
                        </h3>
                      )}
                      {selectedSupplierForBuyer &&
                        params?.supplierDomainId &&
                        location.pathname.startsWith(
                          `/companies/${selectedMainBuyerId}/invoices`
                        ) && (
                          <h3 className="mx-1 whitespace-nowrap text-nowrap sm:text-wrap text-start truncate w-[40vw] sm:w-auto ">
                            {`${capitalizeWordsInSentence(
                              selectedSupplierForBuyer.name?.toLocaleLowerCase()
                            )} Open Items for ${capitalizeWordsInSentence(
                              selectedMainBuyer?.name.toLocaleLowerCase()
                            )}`}
                          </h3>
                        )}
                    </button>
                  )}
                  {selectedMainBuyer === null && <h3 className="page-title">{}</h3>}
                </div>
              )}
              {pathname.startsWith('/reports') && (
                <div>
                  <h3 className="">Reports</h3>
                </div>
              )}
              {pathname.startsWith('/settings') && (
                <div>
                  <h3 className="">Supplier Settings</h3>
                </div>
              )}
              {pathname.startsWith('/virtualPOS') && (
                <div>
                  <h3 className="">Virtual POS</h3>
                </div>
              )}
              {pathname.startsWith('/collectionTasks') && (
                <div>
                  <h3 className="">Collection Tasks</h3>
                </div>
              )}
              {pathname === '/cashApplication' && (
                <div>
                  <h3 className="">Cash Application Review Queue</h3>
                </div>
              )}
              {pathname === '/cashApplication/postHistory' && (
                <div>
                  <h3 className="">Cash Application Post History</h3>
                </div>
              )}
              {pathname === '/cashApplication/dataIntegrations' && (
                <div>
                  <h3 className="">Cash Application Data Integrations</h3>
                </div>
              )}
              {pathname === '/cashApplication/settings' && (
                <div>
                  <h3 className="">Cash Application Settings</h3>
                </div>
              )}
            </div>

            <div className="flex-shrink-0 flex items-center justify-end gap-1">
              {location.pathname.startsWith('/companies') &&
                selectedMainBuyerId &&
                location.pathname.startsWith(`/companies/${selectedMainBuyerId}/invoices`) &&
                location.pathname.split('/').length > 4 && (
                  <div
                    className="mr-2 z-50 flex items-center"
                    data-tooltip-id={!buyerUserCanPay ? 'no_pay_permission' : undefined}>
                    <DillButton
                      label={width >= 940 ? 'Pay Fixed Amount' : ''}
                      variant="secondary"
                      icon={<Money size={19} />}
                      onClick={() => {
                        setIsFixedAmountPaymentsModalOpen(true);
                      }}
                      isDisabled={
                        !selectedSupplierForBuyer ||
                        (selectedSupplierForBuyer &&
                          !canBuyerPaySupplier({ supplier: selectedSupplierForBuyer })) ||
                        !buyerUserCanPay
                          ? true
                          : false
                      }
                    />
                  </div>
                )}

              {currentSupplier &&
                (currentSupplier.integrationType === 'ABLE_MANUAL_UPLOAD' ||
                  currentSupplier.integrationType === 'MANUAL_UPLOAD' ||
                  currentSupplier.integrationType === 'LIEN_ONLY_UPLOAD' ||
                  currentSupplier.integrationType === 'P21_MANUAL_UPLOAD' ||
                  currentSupplier.integrationType === 'DDI_MANUAL_UPLOAD' ||
                  currentSupplier.integrationType === 'ECLIPSE_MANUAL_UPLOAD' ||
                  currentSupplier.integrationType === 'MARKS_MANUAL_UPLOAD' ||
                  currentSupplier.integrationType === 'EAGLE_MANUAL_UPLOAD') &&
                selectAccountType === 'Supplier' && (
                  <div className="mr-2">
                    <DillButton
                      label="Upload Data"
                      variant="secondary"
                      icon={<PlusCircle size={20} />}
                      onClick={() => setOpenImportCSVModal(true)}
                    />
                  </div>
                )}
              <AppProfileView
                onMenuClick={handleProfileViewMenuClick}
                modeType={selectAccountType}
                platformName={platformName}
              />
            </div>
          </div>
          <div className="flex-1 overflow-y-auto relative">
            {width / height < 1 && width > 0 && !location.pathname.includes('/companies') ? (
              <div className="flex absolute p-5 w-full h-full justify-center items-center bg-white flex-col z-50">
                <AlertTriangle color={COLORS.WARNING_600} size={50} />
                <div className="text-center font-medium text-xl text-[#121a2d] mt-2.5">
                  To get the best experience of the Dill portal, please login on the web or expand
                  your window width. Mobile view coming soon
                </div>
              </div>
            ) : isPortalUnderMaintenance ? (
              <div className="flex absolute p-5 w-full h-full justify-center items-center bg-white flex-col z-50">
                <AlertTriangle color={COLORS.WARNING_600} size={50} />
                <div className="text-center font-medium text-xl text-[#121a2d] mt-2.5">
                  Portal undergoing maintenance. Please check back in one business day.
                </div>
              </div>
            ) : (
              <Outlet />
            )}
          </div>
          <ReactTooltip
            id={'locked_user_feature'}
            place="right"
            variant="dark"
            opacity={'100%'}
            style={{
              background: '#222',
              width: '300px',
              zIndex: 99999,
            }}>
            <span>
              These features are locked. If you are interested in learning more, please reach out to
              customer support below
            </span>
          </ReactTooltip>
          <ReactTooltip
            id={'no_pay_permission'}
            place="bottom"
            variant="dark"
            opacity={'100%'}
            style={{
              background: '#222',
              width: '300px',
              zIndex: 99999,
            }}>
            <span>
              You don't have permissions to make payments. Please contact your account admin.
            </span>
          </ReactTooltip>
        </section>
        {/* {width / height < 1 && width > 0 && !location.pathname.includes('/companies') && (
        <div className="warning-pop-up z-50">
          <AlertTriangle color={COLORS.WARNING_600} size={50} />
          <div className="warning-text">
            To get the best experience of the Dill portal, please login on the web or expand your
            window width.
          </div>
        </div>
      )} */}
      </div>
    </div>
  );
};
